(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireedca"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireedca"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("adV76", function(module, exports) {
parcelRequire("iqkY1");
var $9sPuh = parcelRequire("9sPuh");
const fitmix = document.getElementById("fitmix-container");
const productTemplateContainer = document.querySelector('[data-section-type="product-template"]');
let productTryOnButton = document.querySelector(".try-on-product-button");
if (!fitmix || !productTemplateContainer || !productTryOnButton) return;
let frameId = productTryOnButton?.dataset?.frameId;
const lang = productTryOnButton?.dataset?.lang;
let pendingAction = null;
let params = {
    apiKey: "FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt",
    lang: lang ? lang : "en",
    frame: frameId,
    onStopVto: hide,
    watermark: false,
    uiConfiguration: {
        liveRelaunchDetectionButton: false,
        livePhotoButton: false
    }
};
async function initFitMix() {
    try {
        productTryOnButton.setAttribute("aria-disabled", "true");
        await (0, $9sPuh.loadScriptOnIntent)("https://vto-advanced-integration-api.fittingbox.com/index.js", productTryOnButton, {
            mobile: "hover",
            desktop: "hover",
            idleTimeout: 3000,
            checkGlobal: "FitMix",
            sessionKey: "fitmix_interaction",
            enableClickIntent: true
        });
        fitmixInstance = FitMix.createWidget("fitmix-container", params, function() {
            productTryOnButton.setAttribute("aria-disabled", "false");
            if (pendingAction === "open") {
                openVto();
                pendingAction = null;
            }
        });
    } catch (error) {
        productTryOnButton.setAttribute("aria-disabled", "false");
    }
}
initFitMix();
function hide() {
    fitmix.style.display = "none";
    if (productTemplateContainer) productTemplateContainer.classList.remove("try-on-enabled");
}
function show() {
    fitmix.style.display = "block";
    if (productTemplateContainer) productTemplateContainer.classList.add("try-on-enabled");
}
function openVto() {
    sessionStorage.setItem("fitmix_interaction", "true");
    fitmixInstance.startVto("live");
    show();
}
function stopVto() {
    fitmixInstance.stopVto();
    const resizeFlickityEvent = new CustomEvent("product:try-on:closed");
    document.dispatchEvent(resizeFlickityEvent);
}
function toggleTryOn() {
    sessionStorage.setItem("fitmix_interaction", "true");
    if (productTryOnButton.getAttribute("aria-disabled") === "true") {
        pendingAction = "open";
        return;
    }
    if (!productTemplateContainer?.classList.contains("try-on-enabled")) openVto();
    else stopVto();
}
function setTryOnBtnEvent() {
    if (productTryOnButton) productTryOnButton.addEventListener("click", toggleTryOn);
}
document.addEventListener("product-variant-switch:end", ()=>{
    initTryOnButton();
    setTryOnFrame();
});
function initTryOnButton() {
    productTryOnButton = document.querySelector(".try-on-product-button");
    if (productTryOnButton?.dataset?.frameId) setTryOnBtnEvent();
}
function setTryOnFrame() {
    frameId = productTryOnButton?.dataset?.frameId;
    if (!frameId) stopVto();
    else fitmixInstance?.setFrame(frameId);
}
setTryOnBtnEvent();

});
parcelRegister("iqkY1", function(module, exports) {

$parcel$export(module.exports, "debounce", function () { return $d69aeb50f48a55e4$export$61fc7d43ac8f84b0; });
$parcel$export(module.exports, "isTryOnMobile", function () { return $d69aeb50f48a55e4$export$1b5ceeba37b47ff7; });
$parcel$export(module.exports, "loadScriptOnIntent", function () { return (parcelRequire("9sPuh")).loadScriptOnIntent; });

var $9sPuh = parcelRequire("9sPuh");
function $d69aeb50f48a55e4$export$61fc7d43ac8f84b0(fn, wait) {
    let t;
    return (...args)=>{
        clearTimeout(t);
        t = setTimeout(()=>fn.apply(this, args), wait);
    };
}
function $d69aeb50f48a55e4$export$1b5ceeba37b47ff7() {
    return window.innerWidth < 1000;
}

});
parcelRegister("9sPuh", function(module, exports) {

$parcel$export(module.exports, "loadScriptOnIntent", function () { return $6e3eaae17e451e5d$export$fcd80e45dad276ba; });
/**
 * Intent-based script loader utilities
 * Provides smart loading strategies based on user intent and device type
 */ /**
 * Loads a script asynchronously with duplicate prevention
 * @param {string} scriptUrl - URL of the script to load
 * @param {string|null} checkGlobal - Optional window property name to check if script is already loaded (e.g., 'FitMix')
 * @returns {Promise} Resolves when script is loaded, rejects on error
 */ function $6e3eaae17e451e5d$export$f9b12240710a10d(scriptUrl, checkGlobal = null) {
    return new Promise((resolve, reject)=>{
        if (checkGlobal && window[checkGlobal]) {
            resolve();
            return;
        }
        const existingScript = document.querySelector(`script[src="${scriptUrl}"]`);
        if (existingScript) {
            existingScript.addEventListener("load", resolve);
            existingScript.addEventListener("error", reject);
            return;
        }
        const script = document.createElement("script");
        script.src = scriptUrl;
        script.type = "text/javascript";
        script.async = true;
        script.addEventListener("load", resolve);
        script.addEventListener("error", ()=>reject(new Error(`Failed to load script: ${scriptUrl}`)));
        document.head.appendChild(script);
    });
}
function $6e3eaae17e451e5d$export$fcd80e45dad276ba(scriptUrl, element, options = {}) {
    const { mobile: mobile = "viewport", desktop: desktop = "hover", idleTimeout: idleTimeout = 5000, mobileBreakpoint: mobileBreakpoint = 1000, checkGlobal: checkGlobal = null, sessionKey: sessionKey = null, sessionValue: sessionValue = "true", enableClickIntent: enableClickIntent = false } = options;
    return new Promise((resolve, reject)=>{
        const isMobile = window.innerWidth < mobileBreakpoint;
        let strategy = isMobile ? mobile : desktop;
        if (sessionKey && sessionStorage.getItem(sessionKey) === sessionValue) strategy = "immediate";
        let loaded = false;
        const loadScript = async ()=>{
            if (loaded) return;
            loaded = true;
            try {
                await $6e3eaae17e451e5d$export$f9b12240710a10d(scriptUrl, checkGlobal);
                resolve();
            } catch (error) {
                reject(error);
            }
        };
        switch(strategy){
            case "immediate":
                loadScript();
                break;
            case "viewport":
                if ("IntersectionObserver" in window) {
                    const observer = new IntersectionObserver((entries)=>{
                        entries.forEach((entry)=>{
                            if (entry.isIntersecting) {
                                observer.disconnect();
                                loadScript();
                            }
                        });
                    }, {
                        rootMargin: "50px"
                    });
                    observer.observe(element);
                } else loadScript();
                break;
            case "hover":
                const hoverHandler = ()=>{
                    element.removeEventListener("mouseenter", hoverHandler);
                    loadScript();
                };
                element.addEventListener("mouseenter", hoverHandler);
                Promise.all([
                    new Promise((resolve)=>setTimeout(resolve, idleTimeout)),
                    new Promise((resolve)=>{
                        if ("requestIdleCallback" in window) requestIdleCallback(resolve, {
                            timeout: idleTimeout
                        });
                        else resolve();
                    })
                ]).then(loadScript);
                break;
            case "idle":
                if ("requestIdleCallback" in window) requestIdleCallback(()=>loadScript(), {
                    timeout: idleTimeout
                });
                else setTimeout(loadScript, idleTimeout);
                break;
            default:
                reject(new Error(`Unknown loading strategy: ${strategy}`));
        }
        if (enableClickIntent) {
            const clickHandler = ()=>{
                element.removeEventListener("click", clickHandler);
                loadScript();
            };
            element.addEventListener("click", clickHandler);
        }
    });
}

});



parcelRegister("gQTes", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
var $9sPuh = parcelRequire("9sPuh");
const fitmixTryOnContainer = document.getElementById("fitmix-container");
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const firstGlasses = tryonTemplateContainer?.querySelector(".to-glasses-wrapper[data-frame-id]");
let frameIdTryOn = firstGlasses?.dataset?.frameId;
// Early exit if try-on feature is not present on this page
if (!fitmixTryOnContainer || !frameIdTryOn) return;
const langTryOn = tryonTemplateContainer?.dataset?.lang;
let paramsTryOn = {
    apiKey: "FKKyiL0aNESWKAlx1UDeYGlJY6Yw6RQ2o7J7pjXt",
    lang: langTryOn ? langTryOn : "en",
    liveAutostart: true,
    mode: "live",
    frame: frameIdTryOn,
    watermark: false,
    uiConfiguration: {
        liveRelaunchDetectionButton: false,
        livePhotoButton: false
    },
    onPrivacyTermsShown: ()=>tryonTemplateContainer?.classList.add("disclaimer-shown"),
    onAgreePrivacyTerms: ()=>tryonTemplateContainer?.classList.remove("disclaimer-shown"),
    onDisagreePrivacyTerms: ()=>tryonTemplateContainer?.classList.remove("disclaimer-shown"),
    css: `
    #vtoAdvDisclaimer { justify-content: center; align-content: baseline;}
    #vtoAdvDisclaimerShortTerms { font-size: 13px; margin-top: 37px; }
    #vtoAdvDisclaimerTerms { 
      ${!window.tryOnDisclaimerLongText ? "display: none;" : ""}
      ${window.tryOnDisclaimerActivateLong ? "visibility: hidden;" : ""}
      font-size: 14px; 
    }
    #vtoAdvDisclaimerTerms::after {
      display: block;
      visibility: visible;
      margin-top: -25px;
      content: "${window.tryOnDisclaimerActivateLong}";
    }

    [ng-if="isPrivacyPolicyShown"] { height: 60vh; margin-top: 10px; }
  `
};
if (window.tryOnDisclaimerShortText || window.tryOnDisclaimerLongText || window.tryOnDisclaimerAgreeButton || window.tryOnDisclaimerDisagreeButton) paramsTryOn.dataPrivacyDisclaimerTexts = {};
if (window.tryOnDisclaimerShortText) paramsTryOn.dataPrivacyDisclaimerTexts.shortText = tryOnDisclaimerShortText;
if (window.tryOnDisclaimerShortText) paramsTryOn.dataPrivacyDisclaimerTexts.longText = tryOnDisclaimerLongText;
if (window.tryOnDisclaimerAgreeButton) paramsTryOn.dataPrivacyDisclaimerTexts.agreeButton = tryOnDisclaimerAgreeButton;
if (window.tryOnDisclaimerDisagreeButton) paramsTryOn.dataPrivacyDisclaimerTexts.disagreeButton = tryOnDisclaimerDisagreeButton;
async function initFitMix() {
    try {
        await (0, $9sPuh.loadScriptOnIntent)("https://vto-advanced-integration-api.fittingbox.com/index.js", fitmixTryOnContainer, {
            mobile: "viewport",
            desktop: "hover",
            idleTimeout: 5000,
            checkGlobal: "FitMix",
            sessionKey: "fitmix_interaction"
        });
        fitmixInstance = FitMix.createWidget("fitmix-container", paramsTryOn, onFitMixReady);
    } catch (error) {}
}
function onFitMixReady() {
    openVto();
}
function openVto() {
    sessionStorage.setItem("fitmix_interaction", "true");
    fitmixInstance.startVto("live");
    fitmixTryOnContainer.style.display = "block";
}
function initGlassesEvents() {
    const allGlasses = tryonTemplateContainer?.querySelectorAll(".to-glasses-wrapper[data-frame-id]");
    const allConnectedProducts = tryonTemplateContainer?.querySelectorAll(".to-connected-product[data-frame-id]");
    setChangeFrameEvents(allGlasses, false);
    setChangeFrameEvents(allConnectedProducts, true);
}
function setChangeFrameEvents(frames, showOnMobile = true) {
    frames.forEach((frame)=>{
        const frameId = frame.dataset?.frameId;
        if (!frameId) return;
        frame.addEventListener("click", (e)=>{
            e.stopPropagation();
            if (!((0, $iqkY1.isTryOnMobile)() && !showOnMobile)) handleSelection(frame);
        });
    });
}
function setFrame(targetEl) {
    if (targetEl.classList.contains("to-connected-product")) handleSelection(targetEl);
    else {
        const targetElIsWrapper = targetEl.classList.contains("to-glasses-wrapper");
        const glassesWrapper = targetElIsWrapper ? targetEl : targetEl.closest(".to-glasses-wrapper");
        const tempSelFrame = glassesWrapper.querySelector(".to-connected-product:not(.to-cp-not-available)");
        if (tempSelFrame) handleSelection(tempSelFrame);
    }
}
function handleSelection(newSelectedFrame) {
    if (newSelectedFrame.classList.contains("to-cp-not-available")) return;
    const oldSelectedFrame = tryonTemplateContainer?.querySelector(".selected-frame");
    const isWrapper = newSelectedFrame.classList.contains("to-glasses-wrapper");
    if (oldSelectedFrame) oldSelectedFrame?.classList.remove("selected-frame");
    if (isWrapper) newSelectedFrame = newSelectedFrame.querySelector(".to-default-cp");
    newSelectedFrame?.classList.add("selected-frame");
    const frameSelectedEvent = new CustomEvent("try-on:frame-selected");
    setTimeout(document.dispatchEvent(frameSelectedEvent));
    const frameId = newSelectedFrame.dataset.frameId;
    fitmixInstance?.setFrame(frameId);
}
function selectInitialFrame() {
    let selectInitialFrame;
    if ((0, $iqkY1.isTryOnMobile)()) selectInitialFrame = tryonTemplateContainer?.querySelector(".to-connected-product.is-selected:not(.to-cp-not-available");
    else selectInitialFrame = tryonTemplateContainer?.querySelector(".to-connected-product:not(.to-cp-not-available");
    if (!selectInitialFrame) return;
    handleSelection(selectInitialFrame);
}
// Initialize FitMix with intent-based loading
initFitMix();
setTimeout(selectInitialFrame);
initGlassesEvents();
document.addEventListener("try-on:loaded-glasses", ()=>setTimeout(initGlassesEvents));
document.addEventListener("try-on:frame-changed", (e)=>{
    const selectedGlasses = e.detail.selectedGlasses;
    if (selectedGlasses) setFrame(selectedGlasses);
});

});

parcelRegister("h17mq", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const tryonGrid = tryonTemplateContainer?.querySelector(".to__glasses--grid");
const sectionId = tryonGrid?.dataset?.id;
const addToCartButton = tryonTemplateContainer?.querySelector(".to__add-to-cart .loader");
const tryOnGrid = tryonTemplateContainer?.querySelector(".to__glasses--grid");
if (!sectionId || !tryOnGrid) return;
function handleTryOnGridScroll() {
    const scrollPosition = tryOnGrid.scrollTop + tryOnGrid.clientHeight;
    const totalHeight = tryOnGrid.scrollHeight;
    if (totalHeight - scrollPosition <= 200) {
        tryOnGrid?.removeEventListener("scroll", handleTryOnGridScroll);
        initEventHandlers();
    }
}
tryOnGrid.addEventListener("scroll", handleTryOnGridScroll);
function initEventHandlers() {
    const nextPageEls = tryonTemplateContainer?.querySelectorAll(".to-load-more");
    const nextPageEl = nextPageEls[nextPageEls?.length - 1];
    if (!nextPageEl) return;
    const nextURL = nextPageEl.dataset.nextUrl;
    if (!nextURL) return;
    renderSectionFromFetch(nextURL);
}
async function renderSectionFromFetch(nextURL) {
    if (addToCartButton) addToCartButton.classList.add("loading");
    const isMobile = (0, $iqkY1.isTryOnMobile)();
    try {
        const response = await fetch(nextURL);
        const html = await response.text();
        const parser = new DOMParser();
        const fetchedPage = parser.parseFromString(html, "text/html")?.querySelector("body");
        const tryOnGridNew = fetchedPage?.querySelector(".to__glasses--grid");
        const fetchMoreLink = tryOnGrid?.querySelector(".to-load-more");
        const fetchMoreLinkNew = tryOnGridNew?.querySelector(".to-load-more")?.dataset.nextUrl;
        if (tryOnGridNew && !isMobile) tryOnGrid.innerHTML += tryOnGridNew.innerHTML;
        if (isMobile) fetchMoreLink?.setAttribute("data-next-url", fetchMoreLinkNew);
        if (addToCartButton) setTimeout(()=>{
            addToCartButton.classList.remove("loading");
        }, 500);
        if (!isMobile) tryOnGrid.addEventListener("scroll", handleTryOnGridScroll);
        const detail = isMobile ? {
            newSlides: Array.from(tryOnGridNew?.children).map((child)=>child.outerHTML)
        } : {};
        const loadedGlassesEvent = new CustomEvent("try-on:loaded-glasses", {
            detail: detail
        });
        document.dispatchEvent(loadedGlassesEvent);
    } catch (error) {
        console.error("Failed fetching more glasses");
    }
}
document.addEventListener("try-on:load-more-glasses", initEventHandlers);

});

parcelRegister("ghscK", function(module, exports) {
const tryonTemplateContainer = document.querySelector('[data-section-type="try-on-template"]');
const cartWrapper = tryonTemplateContainer?.querySelector(".to__add-to-cart");
if (!cartWrapper) return;
const overlay = cartWrapper?.querySelector(".to__catalogue--overlay");
const atcCloseBtn = cartWrapper?.querySelector(".to__atc__close");
const cartButton = cartWrapper?.querySelector(".to__add-to-cart button");
const addToCartLoader = tryonTemplateContainer?.querySelector(".to__add-to-cart .loader");
const form = cartWrapper?.querySelector("#try-on-prod-form");
const formVariantId = cartWrapper?.querySelector("[data-product-select]");
const formProductId = cartWrapper?.querySelector('[name="product-id"]');
function updateUI() {
    let selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame + [data-json]");
    if (!selectedFrame) selectedFrame = tryonTemplateContainer?.querySelector(".selected-frame [data-json]");
    if (!selectedFrame) return;
    const productData = JSON.parse(selectedFrame.dataset.json);
    if (!productData) return;
    updateInfo(productData);
    updateStrengthOptions(productData);
    updateLensesOptions(productData);
    updateGrid(selectedFrame, productData);
}
function updateGrid(selectedFrame, newProductData) {
    const frameWrapper = selectedFrame.closest(".to-glasses-wrapper");
    const imgEl = frameWrapper?.querySelector(".to-image");
    const titleEl = frameWrapper?.querySelector(".to-title");
    const priceEl = frameWrapper?.querySelector(".to-price");
    const defaultConnectedProd = frameWrapper?.querySelector(".to-default-cp");
    if (titleEl.innerHTML.trim() == newProductData.productTitle.trim()) return;
    if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
    if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
    if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
    if (defaultConnectedProd) {
        defaultConnectedProd.classList.remove("to-default-cp");
        selectedFrame?.previousElementSibling.classList.add("to-default-cp");
    }
}
function updateInfo(newProductData) {
    const imgEl = cartWrapper?.querySelector(".to-image");
    const typeEl = cartWrapper?.querySelector(".to__atc__type");
    const titleEl = cartWrapper?.querySelector(".to__atc__title");
    const priceEl = cartWrapper?.querySelector(".to__atc__price");
    if (imgEl && newProductData.productImage) imgEl.innerHTML = newProductData.productImage;
    if (typeEl && newProductData.type) typeEl.innerHTML = newProductData.type;
    if (titleEl && newProductData.productTitle) titleEl.innerHTML = newProductData.productTitle;
    if (priceEl && newProductData.productPrice) priceEl.innerHTML = newProductData.productPrice;
}
function updateStrengthOptions(newProductData) {
    const strengthContainerEl = cartWrapper?.querySelector(".to__atc_option-strength");
    if (strengthContainerEl && newProductData.productStrengthOptions) {
        const options = newProductData.productStrengthOptions;
        const optionName = "Strength";
        const strengthOptionsEl = strengthContainerEl.querySelector(".to_atc__options");
        const optionsWrapper = document.createElement("div");
        optionsWrapper.classList.add("to_atc__options");
        options.forEach((option, index)=>{
            const id = `--${optionName}-${index}`;
            const radioButton = document.createElement("input");
            radioButton.type = "radio";
            radioButton.classList.add("radio_input");
            radioButton.name = `options[${optionName}]`;
            radioButton.id = id;
            radioButton.value = option.valueName;
            const label = document.createElement("label");
            label.classList.add("to__atc__option");
            label.htmlFor = id;
            label.textContent = option.valueName;
            label.setAttribute("data-variant-id", option.variantId);
            if (!option.available) {
                radioButton.disabled = true;
                label.classList.add("not-available");
            }
            if (newProductData.currentValue?.trim() === option.valueName?.trim()) {
                radioButton.setAttribute("checked", true);
                formVariantId.value = option.variantId;
            }
            optionsWrapper?.append(radioButton);
            optionsWrapper?.append(label);
        });
        formProductId.value = newProductData.id;
        strengthOptionsEl.innerHTML = optionsWrapper.innerHTML;
        strengthContainerEl.classList.add("has-strength");
        setStrengthEvents(strengthOptionsEl);
    } else if (strengthContainerEl) strengthContainerEl.classList.remove("has-strength");
}
function updateLensesOptions(newProductData) {
    const lensesContainerEl = cartWrapper?.querySelector(".to__atc_option-lenses");
    const typeOptions = newProductData.productTypeOptions;
    if (typeOptions && lensesContainerEl) {
        const lensesOptionsEl = lensesContainerEl.querySelector(".to_atc__options");
        const newOptionsWrapper = document.createElement("div");
        const currentType = newProductData.type;
        const typesMap = new Map();
        const opticalType = typeOptions.find((option)=>option.type === "Reading glasses" && option.frameId);
        if (opticalType) typesMap.set("Optical", opticalType);
        const blueLightType = typeOptions.find((option)=>option.type === "Blue light glasses" && option.frameId);
        if (blueLightType) typesMap.set("Blue light", blueLightType);
        const sunglassesType = typeOptions.find((option)=>option.type === "Sunglasses" && option.frameId);
        if (sunglassesType) typesMap.set("Sun", sunglassesType);
        typesMap.set(currentType, {
            ...newProductData,
            current: true
        });
        const types = Object.fromEntries(Array.from(typesMap));
        let index = 0;
        for(const type in types)if (Object.prototype.hasOwnProperty.call(types, type)) {
            const id = `--Lenses-${index}`;
            const radioButton = document.createElement("input");
            radioButton.type = "radio";
            radioButton.classList.add("radio_input");
            radioButton.name = `options[Lenses]`;
            radioButton.id = id;
            radioButton.value = type;
            const label = document.createElement("label");
            label.classList.add("to__atc__option");
            label.htmlFor = id;
            label.textContent = type;
            label.setAttribute("data-product-id", types[type].id);
            label.setAttribute("data-frame-id", types[type].frameId);
            label.setAttribute("data-product-type", types[type].type);
            index++;
            if (types[type].current) radioButton.setAttribute("checked", true);
            if (type == "Reading glasses") {
                newOptionsWrapper?.prepend(label);
                newOptionsWrapper?.prepend(radioButton);
            } else {
                newOptionsWrapper?.append(radioButton);
                newOptionsWrapper?.append(label);
            }
        }
        lensesOptionsEl.innerHTML = newOptionsWrapper.innerHTML;
        lensesContainerEl.classList.add("has-lenses");
        setLensesEvents(lensesContainerEl, types);
    } else if (lensesContainerEl) lensesContainerEl.classList.remove("has-lenses");
}
function setStrengthEvents(container) {
    const strengthOptions = container.querySelectorAll(".to__atc__option:not(.not-available)");
    strengthOptions?.forEach((option)=>{
        const variantId = option.dataset.variantId;
        option.addEventListener("click", ()=>{
            formVariantId.value = variantId;
        });
    });
}
function setLensesEvents(lensesContainerEl, types) {
    const lensesOptions = lensesContainerEl?.querySelectorAll(".to__atc__option");
    lensesOptions?.forEach((lense)=>{
        const productType = lense.dataset.productType;
        const frameId = lense.dataset.frameId;
        const newProductData = Object.values(types).find((option)=>option.type == productType);
        lense.addEventListener("click", ()=>{
            updateInfo(newProductData);
            updateStrengthOptions(newProductData);
            if (frameId && fitmixInstance) fitmixInstance?.setFrame(frameId);
        });
    });
}
function initQuantity() {
    const decrementBtn = cartWrapper.querySelector(".to__atc__quantity .decrement");
    const incrementBtn = cartWrapper.querySelector(".to__atc__quantity .increment");
    const quantityDisplay = cartWrapper.querySelector(".to__atc__quantity .quantity");
    const quantityInput = cartWrapper.querySelector('[name="quantity"]');
    let quantity = quantityDisplay ? parseInt(quantityDisplay.textContent, 10) : 1;
    decrementBtn?.addEventListener("click", ()=>{
        if (quantity > 1) {
            quantity--;
            quantityDisplay.textContent = quantity;
            quantityInput.value = quantity;
        }
    });
    incrementBtn?.addEventListener("click", ()=>{
        quantity++;
        quantityDisplay.textContent = quantity;
        quantityInput.value = quantity;
    });
}
cartButton?.addEventListener("click", (e)=>{
    if (!cartWrapper?.classList.contains("expanded")) setTimeout(()=>cartWrapper?.classList.add("expanded"), 0);
    else e.preventDefault();
});
[
    overlay,
    atcCloseBtn
].forEach((el)=>{
    el?.addEventListener("click", ()=>{
        cartWrapper?.classList.remove("expanded");
    });
});
document.addEventListener("try-on:frame-selected", updateUI);
initQuantity();
form?.addEventListener("submit", (e)=>{
    e.preventDefault();
});

});

parcelRegister("jPzyF", function(module, exports) {

var $iqkY1 = parcelRequire("iqkY1");
const slider = document.querySelector(".to__glasses--grid");
if (!slider) return;
let isMobile = (0, $iqkY1.isTryOnMobile)();
let oldIsMobile = isMobile;
const Flickity = themeVendor.Flickity;
let flkty;
function handleWindowResize() {
    isMobile = (0, $iqkY1.isTryOnMobile)();
    if (isMobile === oldIsMobile) return;
    oldIsMobile = isMobile;
    if (isMobile) initMobileView();
    else destroyMobileView();
}
function initMobileView() {
    flkty = new Flickity(slider, {
        prevNextButtons: false,
        pageDots: false,
        setGallerySize: false,
        cellSelector: ".carousel-cell",
        wrapAround: true,
        on: {
            change: (index)=>{
                debounceTriggerSetFrame(index);
                handleTryOnSliderScroll(index);
            },
            ready: ()=>{
                setTimeout(()=>flkty.resize(), 100);
            },
            staticClick: (event, pointer, cellElement, cellIndex)=>{
                if (cellElement && cellIndex !== flkty.selectedIndex) flkty.select(cellIndex);
            }
        }
    });
    allowCpExpandEvents();
    document.body?.classList.add("to_mobile");
}
function destroyMobileView() {
    flkty.destroy();
    allowCpExpandEvents(false);
    document.body?.classList.remove("to_mobile");
}
const debounceTriggerSetFrame = (0, $iqkY1.debounce)((index)=>{
    const catalougWrapper = document.querySelector(".to__catalogue--wrapper");
    let selectedGlasses = catalougWrapper?.querySelector(".to-glasses-wrapper.is-selected");
    if (!selectedGlasses) selectedGlasses = catalougWrapper?.querySelectorAll(".to-glasses-wrapper")[index - 1];
    const detail = {
        selectedGlasses: selectedGlasses
    };
    const mobileFrameSelected = new CustomEvent("try-on:frame-changed", {
        detail: detail
    });
    document.dispatchEvent(mobileFrameSelected);
}, 200);
function allowCpExpandEvents(enable = true) {
    const expandableConnectedProducts = slider?.querySelectorAll(".to-connected-products.not-expanded");
    expandableConnectedProducts.forEach((expandableCP)=>{
        const expandCpProd = expandConnectedProducts.bind(this, expandableCP);
        if (enable) expandableCP.addEventListener("click", expandCpProd);
        if (!enable) expandableCP.removeEventListener("click", expandCpProd);
    });
    function expandConnectedProducts(expandableCP) {
        expandableCP.classList.remove("not-expanded");
        expandableCP.removeEventListener("click", expandConnectedProducts);
    }
}
function appendNewSlides(e) {
    const elements = e.detail.newSlides;
    if (!elements) return;
    const parser = new DOMParser();
    let newSlides = elements.map((slide)=>parser.parseFromString(slide, "text/html")?.querySelector(".carousel-cell")).filter((slide)=>slide);
    flkty.append(newSlides);
    allowCpExpandEvents();
    document.removeEventListener("try-on:loaded-glasses", appendNewSlides);
}
function handleTryOnSliderScroll(index) {
    const expandableConnectedProducts = slider?.querySelectorAll(".to-connected-products");
    const slides = expandableConnectedProducts?.length;
    if (slides && index >= slides - 4) {
        const loadMoreGlassesEvent = new CustomEvent("try-on:load-more-glasses");
        document.dispatchEvent(loadMoreGlassesEvent);
        document.addEventListener("try-on:loaded-glasses", appendNewSlides);
    }
}
if (isMobile) initMobileView();
window.addEventListener("resize", handleWindowResize);

});

parcelRegister("aJzli", function(module, exports) {
const productPage = document.querySelector(".template-product");
const productSection = document.querySelector('[data-section-type="product-template"]');
const sectionId = productSection?.dataset?.sectionId;
if (!productPage || !productSection || !sectionId) return;
let swatches;
initEventHandlers();
async function updatePageContents(targetUrl) {
    try {
        const response = await fetch(targetUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const fetchedPage = parser.parseFromString(html, "text/html")?.querySelector("body");
        const variantSwitchStartEvent = new CustomEvent("product-variant-switch:start", {
            detail: {
                sectionId: sectionId
            }
        });
        document.dispatchEvent(variantSwitchStartEvent);
        replaceElements(fetchedPage);
        initEventHandlers();
        const variantSwitchEndEvent = new CustomEvent("product-variant-switch:end", {
            detail: {
                sectionId: sectionId
            }
        });
        document.dispatchEvent(variantSwitchEndEvent);
    } catch (err) {
        console.log("Failed to fetch page: ", err);
    }
}
function initEventHandlers() {
    document.addEventListener("click", function(e) {
        const swatch = e.target.classList.contains("siblings__swatch");
        if (!swatch) return;
        e.preventDefault();
        const targetUrl = e.target.href;
        if (!targetUrl) return;
        const retrieveFromURL = targetUrl + "?section_id=" + sectionId;
        history.pushState(null, "", targetUrl);
        updatePageContents(retrieveFromURL);
    });
}
function replaceElements(fetchedPage) {
    const galleryNew = fetchedPage?.querySelector("[data-product-single-media-slider]");
    const galleryThumbnailsNew = fetchedPage?.querySelector("[data-product-single-media-thumbs]");
    const productDetailsNew = fetchedPage?.querySelector(".product-single__details");
    const tryOnBtnNew = fetchedPage?.querySelector(".try-on-product-button");
    const gallery = document.querySelector("[data-product-single-media-slider]");
    const galleryThumbnails = document.querySelector("[data-product-single-media-thumbs]");
    const productDetails = document.querySelector(".product-single__details");
    const tryOnBtn = document.querySelector(".try-on-product-button");
    if (productDetails && productDetailsNew) productDetails.innerHTML = productDetailsNew?.innerHTML;
    if (gallery && galleryNew) gallery.innerHTML = galleryNew?.innerHTML;
    if (galleryThumbnails && galleryThumbnailsNew) galleryThumbnails.innerHTML = galleryThumbnailsNew?.innerHTML;
    if (tryOnBtn && tryOnBtnNew) tryOnBtn.outerHTML = tryOnBtnNew.outerHTML;
}

});

// Override theme breakpoint for product slider (iPad Pro compatibility)
/**
 * GlobalCountdown Web Component
 *
 * A reusable countdown timer with flexible unit display options.
 * Supports smart mode (auto-select), all units, or custom combinations.
 * Can render as visual countdown or text-only format (localized).
 *
 * @example
 * <global-countdown
 *   data-target-date="2025-12-31T23:59:59-05:00"
 *   data-units="hours:minutes:seconds"
 *   data-zero-pad
 *   data-hide-zero-units>
 * </global-countdown>
 *
 * @example Text-only mode
 * <global-countdown
 *   data-target-date="2025-12-31T23:59:59-05:00"
 *   data-units="hours:minutes:seconds"
 *   data-text-only
 *   data-hide-zero-units>
 * </global-countdown>
 */ class $be36d76f30f554f6$var$GlobalCountdown extends HTMLElement {
    constructor(){
        super();
        this.targetDate = this.getAttribute("data-target-date");
        this.unitsMode = this.getAttribute("data-units") || "smart";
        this.hideZero = this.hasAttribute("data-hide-zero");
        this.hideZeroUnits = this.hasAttribute("data-hide-zero-units");
        this.zeroPad = this.hasAttribute("data-zero-pad");
        this.textOnly = this.hasAttribute("data-text-only");
        this.msInSecond = 1000;
        this.msInMinute = 60000;
        this.msInHour = 3600000;
        this.msInDay = 86400000;
        this.msInWeek = 604800000;
        this.animationFrameId = null;
        this.lastUpdateTime = 0;
        this.isTabVisible = true;
        this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
    }
    connectedCallback() {
        this.targetDate = this.getAttribute("data-target-date");
        this.unitsMode = this.getAttribute("data-units") || "smart";
        this.zeroPad = this.getAttribute("data-zero-pad") === "true";
        this.hideZeroUnits = this.getAttribute("data-hide-zero-units") === "true";
        this.hideOnZero = this.getAttribute("data-hide-zero") === "true";
        this.textOnly = this.getAttribute("data-text-only") === "true";
        this.endDate = Date.parse(this.targetDate);
        if (isNaN(this.endDate)) {
            console.error("GlobalCountdown: Invalid target date format", this.targetDate);
            return;
        }
        this.units = this.parseUnits(this.unitsMode);
        this.loadTranslations();
        this.setupAccessibility();
        this.setupVisibilityListener();
        this.startCountdown();
    }
    disconnectedCallback() {
        this.stopCountdown();
        this.cleanupListeners();
    }
    /**
   * Parse unit display configuration
   * @param {string} unitsString - 'smart', 'all', or colon-separated units
   * @returns {Object} Parsed unit configuration
   */ parseUnits(unitsString) {
        if (unitsString === "smart") return {
            mode: "smart"
        };
        if (unitsString === "all") return {
            mode: "all",
            units: [
                "weeks",
                "days",
                "hours",
                "minutes",
                "seconds"
            ]
        };
        const units = unitsString.split(":").map((u)=>u.trim());
        const validUnits = [
            "weeks",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        const filteredUnits = units.filter((u)=>validUnits.includes(u));
        if (filteredUnits.length === 0) {
            console.warn("GlobalCountdown: No valid units specified, defaulting to smart mode");
            return {
                mode: "smart"
            };
        }
        return {
            mode: "custom",
            units: filteredUnits
        };
    }
    /**
   * Load translation strings from data attributes
   */ loadTranslations() {
        this.translations = {
            week: this.getAttribute("data-i18n-week") || "Week",
            weeks: this.getAttribute("data-i18n-weeks") || "Weeks",
            day: this.getAttribute("data-i18n-day") || "Day",
            days: this.getAttribute("data-i18n-days") || "Days",
            hour: this.getAttribute("data-i18n-hour") || "Hour",
            hours: this.getAttribute("data-i18n-hours") || "Hours",
            minute: this.getAttribute("data-i18n-minute") || "Minute",
            minutes: this.getAttribute("data-i18n-minutes") || "Minutes",
            second: this.getAttribute("data-i18n-second") || "Second",
            seconds: this.getAttribute("data-i18n-seconds") || "Seconds"
        };
    }
    /**
   * Setup ARIA attributes for accessibility
   */ setupAccessibility() {
        if (!this.hasAttribute("role")) this.setAttribute("role", "timer");
        if (!this.hasAttribute("aria-live")) this.setAttribute("aria-live", "polite");
        if (!this.hasAttribute("aria-atomic")) this.setAttribute("aria-atomic", "true");
    }
    /**
   * Setup Page Visibility API listener
   */ setupVisibilityListener() {
        document.addEventListener("visibilitychange", this.handleVisibilityChange);
    }
    /**
   * Cleanup event listeners
   */ cleanupListeners() {
        document.removeEventListener("visibilitychange", this.handleVisibilityChange);
    }
    /**
   * Handle tab visibility changes (pause/resume)
   */ handleVisibilityChange() {
        if (document.hidden) {
            this.isTabVisible = false;
            if (this.animationFrameId) {
                cancelAnimationFrame(this.animationFrameId);
                this.animationFrameId = null;
            }
        } else {
            this.isTabVisible = true;
            this.startCountdown();
        }
    }
    /**
   * Start the countdown loop
   */ startCountdown() {
        const updateLoop = (timestamp)=>{
            if (!this.isTabVisible) return;
            const remaining = this.endDate - Date.now();
            if (remaining <= 0) {
                this.handleComplete();
                return;
            }
            if (remaining <= 10000 && this.getAttribute("aria-live") !== "assertive") {
                this.setAttribute("aria-live", "assertive");
                this.setAttribute("role", "alert");
            }
            if (timestamp - this.lastUpdateTime >= 1000) {
                this.render(remaining);
                this.lastUpdateTime = timestamp;
            }
            this.animationFrameId = requestAnimationFrame(updateLoop);
        };
        this.animationFrameId = requestAnimationFrame(updateLoop);
    }
    /**
   * Stop the countdown loop
   */ stopCountdown() {
        if (this.animationFrameId) {
            cancelAnimationFrame(this.animationFrameId);
            this.animationFrameId = null;
        }
    }
    /**
   * Calculate time units from milliseconds
   * @param {number} ms - Milliseconds remaining
   * @returns {Object} Time broken down into units
   */ calculateTimeUnits(ms) {
        const weeks = Math.floor(ms / this.msInWeek);
        const days = Math.floor(ms % this.msInWeek / this.msInDay);
        const hours = Math.floor(ms % this.msInDay / this.msInHour);
        const minutes = Math.floor(ms % this.msInHour / this.msInMinute);
        const seconds = Math.floor(ms % this.msInMinute / this.msInSecond);
        return {
            weeks: weeks,
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds
        };
    }
    /**
   * Render countdown display
   * @param {number} ms - Milliseconds remaining
   */ render(ms) {
        const time = this.calculateTimeUnits(ms);
        if (this.units.mode === "smart") this.renderSmart(time);
        else this.renderUnits(time, this.units.units);
    }
    /**
   * Render smart mode (show only most significant unit)
   * @param {Object} time - Time units object
   */ renderSmart(time) {
        let value, unit;
        if (time.weeks > 0) {
            value = time.weeks;
            unit = "week";
        } else if (time.days > 0) {
            value = time.days;
            unit = "day";
        } else if (time.hours > 0) {
            value = time.hours;
            unit = "hour";
        } else if (time.minutes > 0) {
            value = time.minutes;
            unit = "minute";
        } else {
            value = time.seconds;
            unit = "second";
        }
        this.updateDisplay({
            [unit]: value
        });
    }
    /**
   * Render specific units
   * @param {Object} time - Time units object
   * @param {Array} requestedUnits - Units to display
   */ renderUnits(time, requestedUnits) {
        const displayTime = {};
        const unitMap = {
            weeks: time.weeks,
            days: time.days,
            hours: time.hours,
            minutes: time.minutes,
            seconds: time.seconds
        };
        requestedUnits.forEach((unit)=>{
            const singularUnit = unit.replace(/s$/, "");
            displayTime[singularUnit] = unitMap[unit];
        });
        this.updateDisplay(displayTime);
    }
    /**
   * Update DOM with formatted time
   * @param {Object} timeObj - Object with unit keys and values
   */ updateDisplay(timeObj) {
        if (this.textOnly) this.renderTextOnly(timeObj);
        else this.renderVisualDisplay(timeObj);
    }
    /**
   * Render text-only display (localized list format)
   * @param {Object} timeObj - Object with unit keys and values
   */ renderTextOnly(timeObj) {
        const parts = [];
        Object.entries(timeObj).forEach(([unit, value])=>{
            if (this.hideZeroUnits && value === 0) return;
            const formattedValue = this.zeroPad && value < 10 ? `0${value}` : value;
            const translationKey = value === 1 ? unit : `${unit}s`;
            const label = this.translations[translationKey] || unit;
            parts.push(`${formattedValue} ${label}`);
        });
        if (parts.length === 0) {
            this.textContent = "";
            return;
        }
        const locale = document.documentElement.lang || "en";
        if (typeof Intl !== "undefined" && typeof Intl.ListFormat !== "undefined") try {
            const formatter = new Intl.ListFormat(locale, {
                style: "long",
                type: "conjunction"
            });
            this.textContent = formatter.format(parts);
        } catch (error) {
            console.warn("GlobalCountdown: Intl.ListFormat error, using fallback", error);
            this.textContent = parts.join(" ");
        }
        else this.textContent = parts.join(" ");
    }
    /**
   * Render visual display (HTML structure)
   * @param {Object} timeObj - Object with unit keys and values
   */ renderVisualDisplay(timeObj) {
        let html = "";
        Object.entries(timeObj).forEach(([unit, value])=>{
            if (this.hideZeroUnits && value === 0) return;
            const formattedValue = this.zeroPad && value < 10 ? `0${value}` : value;
            const translationKey = value === 1 ? unit : `${unit}s`;
            const label = this.translations[translationKey] || unit;
            const isSecond = unit === "second";
            const ariaHidden = isSecond ? ' aria-hidden="true"' : "";
            html += `
        <span class="countdown__unit" data-unit="${unit}"${ariaHidden}>
          <strong class="countdown__value" data-value>${formattedValue}</strong>
          <span class="countdown__label" data-label>${label}</span>
        </span>
      `;
        });
        this.innerHTML = `<div class="countdown__units">${html}</div>`;
    }
    /**
   * Handle countdown completion
   */ handleComplete() {
        this.stopCountdown();
        if (this.hideZero) this.style.display = "none";
        else {
            const zeroTime = this.units.mode === "smart" ? {
                second: 0
            } : this.units.units.reduce((acc, unit)=>{
                acc[unit.replace(/s$/, "")] = 0;
                return acc;
            }, {});
            this.updateDisplay(zeroTime);
        }
        this.dispatchEvent(new CustomEvent("countdown:complete", {
            bubbles: true,
            detail: {
                endDate: this.endDate
            }
        }));
    }
}
if (!customElements.get("global-countdown")) customElements.define("global-countdown", $be36d76f30f554f6$var$GlobalCountdown);


if (!customElements.get("style-guide")) {
    class StyleGuide extends HTMLElement {
        constructor(){
            super();
            this.setEventListeners();
            this.startGuide();
        }
        async startGuide() {
            this.intro = this.querySelector(".question-and-answer-wrap[data-step='0']");
            this.totalSteps = this.getAttribute("data-total-steps");
            this.questionIndex = 0;
            this.targetCollection = this.getAttribute("data-target-collection");
            this.redirectDelay = this.getAttribute("data-redirect-delay");
            this.typeDelay = this.getAttribute("data-type-delay");
            document.querySelector("body").style.overflow = "hidden"; // remove scroll on body
            this.intro.classList.add("ready");
            await this.showText(this.intro); // Wait for intro text to finish
            this.startStep(1); // Then start step 1
        }
        setEventListeners() {
            this.querySelectorAll(".answer").forEach((answer)=>{
                answer.addEventListener("click", this.selectOption.bind(this));
            });
            this.querySelector(".close-icon").addEventListener("click", this.returnToPreviousPage);
        }
        selectOption(event) {
            const selectedOption = event.target.closest(".answer");
            const optionQuestion = event.target.closest(".question-and-answer-wrap");
            const optionQuestionIndex = optionQuestion.getAttribute("data-step");
            // deselect all other option in this question
            optionQuestion.querySelectorAll(".answer").forEach((option)=>{
                option.classList.remove("selected");
            });
            // select the clicked option
            selectedOption.classList.add("selected");
            // start the next step if the option that is changed is part of the last question that has been opened
            if (parseInt(optionQuestionIndex) == this.questionIndex) {
                const newProgress = this.questionIndex * (90 / this.totalSteps) + 10 + "%";
                this.style.setProperty("--progress", newProgress);
                if (this.questionIndex == this.totalSteps) this.completeGuide();
                else this.startStep(this.questionIndex + 1);
            }
        }
        async startStep(index) {
            this.questionIndex = index;
            const questionWrap = this.querySelector(".question-and-answer-wrap[data-step='" + index + "']");
            const answersWrap = questionWrap.querySelector(".answers-wrap");
            const scrollWrap = document.querySelector(".style-guide__questions-wrapper");
            questionWrap.classList.add("ready");
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            await this.showText(questionWrap); // Wait for each text in step 1 to show one by one
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            answersWrap.classList.add("ready"); // then show the answer options
            scrollWrap.scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            window.scrollBy(0, 48); // Scroll 3rem (48px) further after block end
        }
        async showText(elem) {
            elem.textStrings = elem.querySelectorAll("[data-text]");
            // Loop through each text string and await its animation one by one
            for (const textString of elem.textStrings)await this.animateText(textString); // Wait for the current text to finish before moving to the next
        }
        // Animate text and return a Promise that resolves when animation completes
        animateText(textString) {
            return new Promise((resolve)=>{
                const text = textString.getAttribute("data-text");
                let index = 0;
                function animateText() {
                    textString.textContent = text.slice(0, index);
                    index++;
                    if (index > text.length) {
                        clearInterval(intervalId); // Stop when the text is fully displayed
                        resolve(); // Resolve when the text animation is complete
                    }
                }
                const intervalId = setInterval(animateText, this.typeDelay);
            });
        }
        completeGuide() {
            // show guide complete message and loading animation
            this.querySelector(".quiz-complete-wrap").classList.add("ready");
            document.querySelector(".style-guide__questions-wrapper").scrollIntoView({
                behavior: "smooth",
                block: "end"
            });
            this.querySelectorAll(".animated_dot").forEach((dot)=>{
                dot.style.animationPlayState = "running";
            });
            // create filterURL and redirect after the chosen "loading" delay
            setTimeout(()=>{
                const urlString = this.createFilterURL();
                window.location.href = urlString;
            }, this.redirectDelay);
        }
        createFilterURL() {
            let urlString = "/collections/" + this.targetCollection + "?sort_by=title-ascending";
            let index = 0;
            this.querySelectorAll(".question-and-answer-wrap").forEach((question)=>{
                if (question.querySelector(".answer.selected")) {
                    index++;
                    const filterHandle = question.getAttribute("data-filter-handle");
                    const selectedOptionHandles = question.querySelector(".answer.selected").getAttribute("data-option-handle").split(",");
                    selectedOptionHandles.forEach((handle)=>{
                        const questionString = "&" + filterHandle + "=" + handle;
                        urlString = urlString + questionString;
                    });
                }
            });
            return urlString;
        }
        returnToPreviousPage() {
            window.history.back();
        }
    }
    customElements.define("style-guide", StyleGuide);
}


function $196e129cf5f68d08$var$initWidget(openWidget) {
    const cartWidget = $196e129cf5f68d08$var$getUniqueElement("#cart-widget");
    const openPopupBtn = $196e129cf5f68d08$var$getUniqueElement("#open-popup-button");
    if (!cartWidget || !openPopupBtn) return;
    let cartData = cartWidget.querySelector("[data-cart]")?.dataset?.cart;
    if (!cartData) return;
    else cartData = JSON.parse(cartData);
    const lastAddedProductName = cartData.find((item)=>item.type !== "Accessories")?.title;
    const cartWidgetProductNames = cartWidget.querySelectorAll(".cart__widget__product-name");
    const lastAddedProduct = [
        ...cartWidgetProductNames
    ].find((item)=>{
        if (lastAddedProductName?.includes(item.innerText)) return true;
    });
    const closeBtns = cartWidget.querySelectorAll(".cart__widget__close-button");
    const removeProductBtns = cartWidget.querySelectorAll(".cart__widget__card-x");
    const tabButtons = cartWidget.querySelectorAll(".cart__widget__tab-button");
    const tabContents = cartWidget.querySelectorAll(".cart__widget__tab-content-item");
    const checkoutButtons = cartWidget?.querySelectorAll(".cart__widget__checkout-button");
    $196e129cf5f68d08$var$setDescriptionTextCount(tabContents);
    $196e129cf5f68d08$var$setActiveView(lastAddedProduct, tabButtons, tabContents);
    $196e129cf5f68d08$var$setEventListeners({
        cartWidget: cartWidget,
        tabButtons: tabButtons,
        tabContents: tabContents,
        openPopupBtn: openPopupBtn,
        closeBtns: closeBtns,
        removeProductBtns: removeProductBtns,
        checkoutButtons: checkoutButtons
    });
    if (lastAddedProduct) {
        if (openWidget) $196e129cf5f68d08$var$setActive(cartWidget, false);
        $196e129cf5f68d08$var$setActive(openPopupBtn, true);
    }
    if (!lastAddedProduct) {
        $196e129cf5f68d08$var$setActive(cartWidget, false);
        $196e129cf5f68d08$var$setActive(openPopupBtn, false);
    }
}
function $196e129cf5f68d08$var$setActive(element, enable) {
    if (enable) element.classList.add("active");
    if (!enable) element.classList.remove("active");
}
function $196e129cf5f68d08$var$setWidget(chosenElement, elements) {
    elements.forEach(function(el) {
        $196e129cf5f68d08$var$setActive(el, false);
    });
    $196e129cf5f68d08$var$setActive(chosenElement, true);
}
function $196e129cf5f68d08$var$getUniqueElement(elId) {
    const els = document.querySelectorAll(elId);
    let uniqueEl;
    els.forEach((el, index)=>{
        if (index == 0) uniqueEl = el;
        if (index > 0) el.remove();
    });
    return uniqueEl;
}
function $196e129cf5f68d08$var$setDescriptionTextCount(tabContents) {
    tabContents.forEach((tabContent)=>{
        const emptyBoxes = tabContent.querySelectorAll(".empty")?.length;
        const desc = tabContent.querySelector(".cart__widget__description");
        if (!desc) return;
        const unlockOfferText = desc?.dataset?.unlockText || "";
        const text = desc?.innerText;
        const newText = emptyBoxes && text ? text.replace(/{{\s*count\s*}}/g, emptyBoxes) : unlockOfferText;
        desc.innerText = newText;
    });
}
function $196e129cf5f68d08$var$setActiveView(lastAddedProduct, tabButtons, tabContents) {
    if (!lastAddedProduct || !tabButtons.length || !tabContents.length) return;
    const lastAddedTabContent = lastAddedProduct.closest(".cart__widget__tab-content-item");
    console.log("last added tab content", lastAddedTabContent, lastAddedProduct);
    const lastTabName = lastAddedTabContent?.id;
    const lastTabButton = lastAddedTabContent?.closest(".cart__widget__tab-content")?.previousElementSibling?.querySelector(`[data-tab-target="${lastTabName}"]`);
    if (lastTabButton) $196e129cf5f68d08$var$setWidget(lastTabButton, tabButtons);
    if (lastAddedTabContent) $196e129cf5f68d08$var$setWidget(lastAddedTabContent, tabContents);
}
function $196e129cf5f68d08$var$getProductData(formDataArray) {
    const productData = formDataArray.reduce((acc, [key, value])=>{
        // Extract the index (1, 2, 3) from the key
        const match = key.match(/items\[(\d+)]\[(id|quantity)]/);
        if (match) {
            // index is a number, field is 'id' or 'quantity'
            const [, index, field] = match;
            // Find or create the object for this index
            const existingItem = acc[index - 1] || {
                id: null,
                quantity: null
            };
            existingItem[field] = Number(value);
            // Add obj at the correct index
            acc[index - 1] = existingItem;
        }
        return acc;
    }, []);
    return productData;
}
async function $196e129cf5f68d08$var$addToCart(productData) {
    const requestBody = {
        items: productData
    };
    try {
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(requestBody)
        });
        const json = await response.json();
        if (json.items) return {
            success: true
        };
        else return {
            success: false,
            response: json.description
        };
    } catch (error) {
        return {
            success: false,
            response: error
        };
    }
}
function $196e129cf5f68d08$var$setEventListeners({ cartWidget: cartWidget, tabButtons: tabButtons, tabContents: tabContents, openPopupBtn: openPopupBtn, closeBtns: closeBtns, removeProductBtns: removeProductBtns, checkoutButtons: checkoutButtons }) {
    const powerStepForm = cartWidget?.querySelector("#care-package-form");
    const acceptPowerStepBtn = cartWidget?.querySelector(".accept-power-step");
    const errorMessageContainer = cartWidget?.querySelector(".power-step-error-message ");
    powerStepForm?.addEventListener("submit", async (e)=>{
        e.preventDefault();
        const formData = new FormData(e.target);
        const productData = $196e129cf5f68d08$var$getProductData(Array.from(formData));
        $196e129cf5f68d08$var$setActive(errorMessageContainer, false);
        acceptPowerStepBtn.classList.add("loading");
        const resp = await $196e129cf5f68d08$var$addToCart(productData);
        acceptPowerStepBtn.classList.remove("loading");
        if (resp?.success || resp?.response?.includes("You can't add more")) window.location.href = "/checkout";
        else {
            $196e129cf5f68d08$var$setActive(errorMessageContainer, true);
            errorMessageContainer.innerHTML = resp?.response;
        }
    });
    tabButtons.forEach((button)=>{
        button.addEventListener("click", function() {
            const targetId = button.dataset.tabTarget;
            const content = cartWidget.querySelector(`#${targetId}`);
            $196e129cf5f68d08$var$setWidget(button, tabButtons);
            $196e129cf5f68d08$var$setWidget(content, tabContents);
        });
    });
    removeProductBtns.forEach((btn)=>{
        btn.addEventListener("click", function() {
            const openCartBtn = document.querySelector('.cart__toggle[aria-expanded="false"]');
            if (openCartBtn) openCartBtn.click();
            const cartDrawer = document.querySelector("#cart-drawer");
            const productTitle = btn.dataset.productTitle;
            const removeButton = cartDrawer?.querySelector(`[data-item-title="${productTitle}"]`)?.querySelector(".cart__item__remove");
            if (removeButton) removeButton.click();
        });
    });
    checkoutButtons.forEach((checkoutBtn)=>{
        const mainWidgetContent = cartWidget.querySelector(".cart__widget__main-step");
        const powerStepContent = cartWidget.querySelector(".cart__widget__power-step");
        checkoutBtn.addEventListener("click", ()=>{
            const powerProdInCart = cartWidget?.querySelector("[data-power-prod-in-cart]");
            if (powerProdInCart) {
                window.location.href = "/checkout";
                return;
            }
            $196e129cf5f68d08$var$setActive(mainWidgetContent, false);
            $196e129cf5f68d08$var$setActive(powerStepContent, true);
        });
    });
    // Close widget when outside click
    document.addEventListener("click", (e)=>{
        const clickTarget = e.target;
        const isOpenButton = clickTarget?.classList.contains("cart__open-button");
        !cartWidget.contains(clickTarget) && !isOpenButton && $196e129cf5f68d08$var$setActive(cartWidget, false);
    });
    openPopupBtn?.addEventListener("click", ()=>$196e129cf5f68d08$var$setActive(cartWidget, true));
    closeBtns.forEach((closeBtn)=>{
        closeBtn?.addEventListener("click", ()=>$196e129cf5f68d08$var$setActive(cartWidget, false));
    });
}
$196e129cf5f68d08$var$initWidget();
document.addEventListener("cart-widget:updated", (e)=>{
    $196e129cf5f68d08$var$initWidget(e.detail.isSupposedToTriggerWidget);
});


class $2bb81151451f121c$var$ColorSwatches extends HTMLElement {
    constructor(){
        super();
        this.collectionProductWrapper = this.closest(".collection__products");
        this.productGridItem = this.closest(".product-grid-item");
        this.originalSwatches = this.productGridItem.querySelector(".original-swatches color-swatches");
        this.limitColorSwatchOptions();
        this.addEventListener("change", this.onColorSwatchChange);
    }
    onColorSwatchChange(ev) {
        let currentSwatch = ev.target;
        if (currentSwatch.tagName !== "INPUT") currentSwatch = currentSwatch.querySelector("input");
        if (!currentSwatch) return;
        this.updateMasterDataset(currentSwatch);
        if (this.variantId) this.renderProduct(currentSwatch);
    }
    limitColorSwatchOptions() {
        const limit = 4;
        const allColorSwatchOptions = this.querySelectorAll("li.connected-product__swatch");
        if (!allColorSwatchOptions) return;
        const allColorSwatchLen = allColorSwatchOptions.length;
        if (allColorSwatchLen <= limit) return;
        const swatchArray = Array.from(allColorSwatchOptions);
        const excessSwatches = swatchArray.slice(limit);
        excessSwatches.forEach((swatch)=>swatch.remove());
        const moreSwatch = document.createElement("li");
        moreSwatch.className = "connected-product__swatch more-swatch";
        moreSwatch.textContent = "+";
        swatchArray[limit - 1].parentNode.appendChild(moreSwatch);
        moreSwatch.addEventListener("click", (event)=>{
            event.preventDefault();
            event.stopPropagation();
            const cardWrapper = moreSwatch.closest(".product-grid-item__inner");
            const productLink = cardWrapper?.querySelector('a[href*="/products/"]');
            if (productLink) productLink.click();
        });
    }
    updateProductOptions() {
        try {
            const fieldsets = Array.from(this.querySelectorAll("fieldset"));
            if (!fieldsets) return;
            this.options = fieldsets.map((fieldset)=>{
                return {
                    value: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).value,
                    connectedProductId: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.connectedProductId,
                    connectedProductHandle: Array.from(fieldset.querySelectorAll("input")).find((radio)=>radio.checked).dataset.handle
                };
            });
        } catch (e) {
            console.warn("error:", e);
        }
    }
    updateMasterDataset(currentSwatch) {
        this.productId = currentSwatch.dataset.connectedProductId;
        this.variantId = currentSwatch.dataset.connectedVariantId;
        this.productHandle = currentSwatch.dataset.handle;
    }
    async renderProduct(currentSwatch) {
        try {
            const response = await fetch(`/products/${this.productHandle}?section_id=product-grid-item-section`);
            const responseText = await response.text();
            const parsedHtml = new DOMParser().parseFromString(responseText, "text/html");
            const productGridItem = parsedHtml.querySelector(".product-grid-item .product-grid-item__inner ");
            this.renderNewSwatches(productGridItem, currentSwatch);
        } catch (error) {
            console.error("Error fetching product data", error);
        }
    }
    renderNewSwatches(productGridItem, currentSwatch) {
        const newGridItem = this.closest(".product-grid-item .product-grid-item__inner");
        newGridItem.innerHTML = productGridItem.innerHTML;
        const newColorSwatches = newGridItem.querySelector("color-swatches");
        newColorSwatches.innerHTML = this.originalSwatches.innerHTML;
        this.activateSwatch(newColorSwatches, currentSwatch);
    }
    activateSwatch(newColorSwatches, currentSwatch) {
        const currentSwatchVariantId = currentSwatch.dataset.connectedVariantId;
        const newColorSwatchesElements = newColorSwatches.querySelectorAll("li input");
        newColorSwatchesElements.forEach((swatch)=>{
            swatch.classList.remove("selected");
        });
        const newColorSwatchesElementsArray = [
            ...newColorSwatchesElements
        ];
        newColorSwatchesElementsArray.find((swatch)=>swatch.dataset.connectedVariantId === currentSwatchVariantId).classList.add("selected");
    }
}
$2bb81151451f121c$var$ColorSwatches.productData = [];
customElements.define("color-swatches", $2bb81151451f121c$var$ColorSwatches);


(function() {
    function updateFilterCount() {
        const urlParams = new URLSearchParams(window.location.search);
        let filterCount = 0;
        for (const [key, value] of urlParams.entries())if (key !== "sort_by" && key !== "page" && key !== "view" && key !== "filter.v.availability") filterCount++;
        const filtersToggle = document.querySelector("[data-toggle-filters]");
        if (filtersToggle) {
            let buttonText = filtersToggle.innerHTML;
            if (filterCount === 0) buttonText = buttonText.replace(/\s*$$\d+$$/, "");
            else if (buttonText.includes("(")) buttonText = buttonText.replace(/$$\d+$$/, `(${filterCount})`);
            else buttonText = buttonText.replace(/<span>(.+?)<\/span>/, `<span>$1</span> (${filterCount})`);
            filtersToggle.innerHTML = buttonText;
        }
        return filterCount;
    }
    window.updateFilterCount = updateFilterCount;
    document.addEventListener("DOMContentLoaded", updateFilterCount);
    document.addEventListener("ajaxComplete", updateFilterCount);
    let lastUrl = window.location.href;
    setInterval(function() {
        if (lastUrl !== window.location.href) {
            lastUrl = window.location.href;
            updateFilterCount();
        }
    }, 100);
    updateFilterCount();
})();


/**
 * Filtered Product List Web Component
 *
 * Dynamically loads and filters products via Shopify Section Rendering API
 * Replaces skeleton cards with real products based on liquid filter parameters
 */ class $af4a55e1509d5ac0$var$FilteredProductList extends HTMLElement {
    constructor(){
        super();
        this.observer = null;
        this.hasLoaded = false;
    }
    connectedCallback() {
        this.sectionId = this.getAttribute("section-id");
        this.collectionUrl = this.getAttribute("collection-url");
        this.parameters = new URLSearchParams();
        this.productId = this.getAttribute("product-id");
        this.minimumVisible = Number(this.getAttribute("minimum-visible")) || 0;
        this.maximumVisible = Number(this.getAttribute("maximum-visible")) || 20;
        if (Number.isNaN(this.minimumVisible)) this.minimumVisible = 0;
        // Parse filter parameters from liquid output
        const filterString = this.getAttribute("filters")?.trim() || "";
        const filterParameters = filterString.split(",").filter((param)=>param.trim());
        for (const param of filterParameters){
            const [key, value] = param.split("=");
            if (!key || !value) continue;
            this.parameters.append(key.trim(), value.trim());
        }
        // Add required parameters
        this.parameters.set("section_id", this.sectionId);
        this.parameters.set("filter.v.availability", "1"); // Only show available products
        // Only setup observer if we have filters to apply
        if (filterParameters.length > 0) this.setupObserver();
    }
    setupObserver() {
        const options = {
            root: null,
            rootMargin: "20% 0px",
            threshold: 0
        };
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting && !this.hasLoaded) {
                    this.hasLoaded = true;
                    this.loadContent();
                    this.observer.disconnect();
                }
            });
        }, options);
        this.observer.observe(this);
    }
    /**
   * Helper: Find product cards in the document using multiple selector strategies
   */ findProductCards(doc) {
        const selectors = [
            ".product-grid-item",
            "[data-product-block]",
            ".grid__item",
            ".carousel__item"
        ];
        for (const selector of selectors){
            const cards = doc.querySelectorAll(selector);
            if (cards.length > 0) {
                // Filter to ensure we only get actual product cards, not promo blocks
                const productCards = [
                    ...cards
                ].filter((card)=>{
                    // Exclude promo blocks (they never have product-grid-item class)
                    if (card.classList.contains("collection-promo") || card.hasAttribute("data-promo")) return false;
                    // Must have product-grid-item class or data-product-block attribute
                    return card.classList.contains("product-grid-item") || card.hasAttribute("data-product-block");
                });
                if (productCards.length > 0) return productCards;
            }
        }
        console.warn("No product cards found in response");
        return [];
    }
    /**
   * Helper: Extract product ID from a product card element
   * Product cards have ID format: "product-item--{section-id}-{product-id}"
   */ getProductIdFromCard(card) {
        // Try to get product ID from the card's ID attribute
        // Format: "product-item--{section-id}-{product-id}"
        const cardId = card.id;
        if (cardId && cardId.startsWith("product-item--")) {
            const parts = cardId.split("-");
            const productId = parts[parts.length - 1];
            if (productId) return productId;
        }
        // Fallback: Look for product form with data-product-form
        const productForm = card.querySelector("[data-product-form]");
        if (productForm && productForm.id) {
            // Form ID format: "{section-id}-{product-id}"
            const formParts = productForm.id.split("-");
            const productId = formParts[formParts.length - 1];
            if (productId) return productId;
        }
        // Fallback: Look for product link
        const productLink = card.querySelector('a[href*="/products/"]');
        if (productLink) {
            const href = productLink.getAttribute("href");
            const match = href.match(/\/products\/([^?#]+)/);
            if (match) return match[1]; // Return product handle
        }
        return null;
    }
    /**
   * Helper: Preserve static content elements before DOM replacement
   * Finds all elements with data-static attribute and stores their outerHTML
   * @param {Element} container - The container to search for static elements
   * @returns {Map} Map of data-static keys to outerHTML strings
   */ preserveStaticContent(container) {
        const staticElements = container.querySelectorAll("[data-static]");
        const preserved = new Map();
        staticElements.forEach((element)=>{
            const key = element.getAttribute("data-static");
            if (key) preserved.set(key, element.outerHTML);
        });
        return preserved;
    }
    /**
   * Helper: Restore static content elements after DOM replacement
   * Finds all elements with data-static attribute and replaces them with preserved content
   * @param {Element} container - The container to search for static elements
   * @param {Map} preserved - Map of data-static keys to outerHTML strings
   */ restoreStaticContent(container, preserved) {
        if (!preserved || preserved.size === 0) return;
        const staticElements = container.querySelectorAll("[data-static]");
        staticElements.forEach((element)=>{
            const key = element.getAttribute("data-static");
            if (key && preserved.has(key)) element.outerHTML = preserved.get(key);
        });
    }
    /**
   * Helper: Update collection links with filter parameters
   * Updates the view all button and heading link hrefs with filter query params
   * @param {Element} container - The container to search for links
   */ updateCollectionLinks(container) {
        // Build filter query string (without section_id)
        const params = new URLSearchParams(this.parameters);
        params.delete("section_id");
        const filterQuery = params.toString();
        if (!filterQuery) return;
        // Update all view all buttons (desktop + mobile)
        const viewAllButtons = container.querySelectorAll(".btn--view-all");
        viewAllButtons.forEach((button)=>{
            button.href = `${this.collectionUrl}?${filterQuery}`;
        });
        // Update heading link if it exists
        const headingLink = container.querySelector(".section__link");
        if (headingLink) headingLink.href = `${this.collectionUrl}?${filterQuery}`;
    }
    async loadContent() {
        try {
            const url = `${this.collectionUrl}?${this.parameters.toString()}`;
            const response = await fetch(url);
            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
            const html = await response.text();
            const shopifySection = this.closest(".shopify-section");
            if (!shopifySection) {
                console.error("Could not find .shopify-section container");
                return;
            }
            // Parse the response HTML
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            // Find product cards using dynamic selector
            const productCards = this.findProductCards(doc);
            if (productCards.length === 0) {
                console.error("No products found in Section Rendering API response");
                this.hideSection();
                return;
            }
            // Count actual products (excluding current product if on PDP)
            let validProductCount = productCards.length;
            // Remove current product from the list if on PDP
            if (this.productId) {
                const currentProductIndex = productCards.findIndex((card)=>{
                    const cardProductId = this.getProductIdFromCard(card);
                    return cardProductId && cardProductId === this.productId;
                });
                if (currentProductIndex !== -1) {
                    const productToRemove = productCards[currentProductIndex];
                    // The product card itself IS the grid/carousel item
                    productToRemove.remove();
                    productCards.splice(currentProductIndex, 1);
                    validProductCount--;
                }
            }
            // Limit to maximum visible products if needed
            if (validProductCount > this.maximumVisible) {
                const cardsToRemove = productCards.slice(this.maximumVisible);
                cardsToRemove.forEach((card)=>{
                    // The product card itself IS the grid/carousel item
                    card.remove();
                });
                validProductCount = this.maximumVisible;
            }
            // Check if we have enough products to show
            if (validProductCount < this.minimumVisible) {
                this.hideSection();
                return;
            }
            // Find the section container (with data-section-type attribute)
            const sectionContainer = shopifySection.querySelector('[data-section-type="filtered-collection"]');
            const newSectionContainer = doc.querySelector('[data-section-type="filtered-collection"]');
            if (!sectionContainer || !newSectionContainer) {
                console.error("Could not find section containers");
                return;
            }
            // Get the section instance from Shopify's section management system
            const instance = window.Shopify?.theme?.sections?.instances?.find((inst)=>inst.id === this.sectionId) || null;
            // Preserve static content (e.g., product-specific headings) before replacement
            const preservedContent = this.preserveStaticContent(sectionContainer);
            // Unload the old section instance (cleanup carousels, etc.)
            if (instance && typeof instance.onUnload === "function") instance.onUnload();
            // Replace the content (preserves the section container)
            sectionContainer.innerHTML = newSectionContainer.innerHTML;
            // Restore static content (e.g., product-specific headings) after replacement
            this.restoreStaticContent(sectionContainer, preservedContent);
            // Update collection links with filter parameters (after static restoration)
            this.updateCollectionLinks(sectionContainer);
            // Reload the section instance (reinitialize carousels, etc.)
            if (instance && typeof instance.onLoad === "function") instance.onLoad();
            // Dispatch event for other features to reinitialize (e.g., sticky product)
            this.reinitializeScripts();
        } catch (error) {
            console.error("Failed to load filtered products:", error);
            // On error, hide the section gracefully
            this.hideSection();
        }
    }
    hideSection() {
        const shopifySection = this.closest(".shopify-section");
        if (shopifySection) shopifySection.style.display = "none";
    }
    reinitializeScripts() {
        // Reinitialize AOS (Animate On Scroll) if present
        if (window.AOS) window.AOS.refresh();
        // Dispatch custom event for other scripts to hook into
        document.dispatchEvent(new CustomEvent("filtered-product-list:loaded", {
            detail: {
                sectionId: this.sectionId
            }
        }));
    }
    disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
    }
}
// Register the custom element
if (!customElements.get("filtered-product-list")) customElements.define("filtered-product-list", $af4a55e1509d5ac0$var$FilteredProductList);
var $af4a55e1509d5ac0$export$2e2bcd8739ae039 = $af4a55e1509d5ac0$var$FilteredProductList;


let $6fb182d98681d142$var$modal;
let $6fb182d98681d142$var$closeBody;
let $6fb182d98681d142$var$newsLetterSub;
let $6fb182d98681d142$var$submitContainer;
let $6fb182d98681d142$var$termsInput;
let $6fb182d98681d142$var$submitBtn;
function $6fb182d98681d142$var$handleModal() {
    const iFrame = document.querySelector("#klaviyo-bis-iframe");
    const iframeDoc = iFrame.contentDocument || iFrame.contentWindow.document;
    setTimeout(()=>{
        const body = iframeDoc?.body;
        $6fb182d98681d142$var$modal = body?.querySelector("#klaviyo-bis-modal");
        $6fb182d98681d142$var$closeBody = $6fb182d98681d142$var$modal.querySelector(".klaviyo-bis-close");
        if (!$6fb182d98681d142$var$modal) return;
        $6fb182d98681d142$var$showModal(true);
        $6fb182d98681d142$var$moveNewsletterBelowSubmit();
        $6fb182d98681d142$var$addTermsCheckbox();
        $6fb182d98681d142$var$handleInputValidation();
        $6fb182d98681d142$var$handleCloseButton();
        $6fb182d98681d142$var$handleSlideOut(body);
    });
}
function $6fb182d98681d142$var$showModal(show) {
    $6fb182d98681d142$var$modal.classList.toggle("show", show);
    $6fb182d98681d142$var$modal.classList.toggle("hide", !show);
    if (!show) setTimeout(()=>$6fb182d98681d142$var$closeBody.click(), 500);
}
function $6fb182d98681d142$var$moveNewsletterBelowSubmit() {
    $6fb182d98681d142$var$submitContainer = $6fb182d98681d142$var$modal.querySelector(".submit-container");
    $6fb182d98681d142$var$newsLetterSub = $6fb182d98681d142$var$modal.querySelector("#newsletter_subscription");
    if ($6fb182d98681d142$var$newsLetterSub) $6fb182d98681d142$var$submitContainer?.insertAdjacentElement("afterend", $6fb182d98681d142$var$newsLetterSub);
}
function $6fb182d98681d142$var$addTermsCheckbox() {
    if (!$6fb182d98681d142$var$newsLetterSub) return;
    const terms = $6fb182d98681d142$var$newsLetterSub?.cloneNode(true);
    const termsLabel = terms?.querySelector("label");
    $6fb182d98681d142$var$termsInput = terms?.querySelector("input");
    if (!$6fb182d98681d142$var$termsInput || !termsLabel || !window.termsPrivacyText) return;
    termsLabel.htmlFor = "terms_and_privacy";
    $6fb182d98681d142$var$termsInput.id = "terms_and_privacy";
    termsLabel.innerHTML = window.termsPrivacyText;
    $6fb182d98681d142$var$newsLetterSub.insertAdjacentElement("afterend", terms);
}
function $6fb182d98681d142$var$handleInputValidation() {
    const email = $6fb182d98681d142$var$modal.querySelector('input[type="email"]');
    $6fb182d98681d142$var$submitBtn = $6fb182d98681d142$var$submitContainer?.querySelector('button[type="submit"]');
    if (!email || !$6fb182d98681d142$var$submitBtn || !$6fb182d98681d142$var$termsInput) return;
    $6fb182d98681d142$var$submitBtn.disabled = true;
    [
        email,
        $6fb182d98681d142$var$termsInput
    ].forEach((input)=>{
        input.addEventListener("input", ()=>{
            if (email.value != "" & $6fb182d98681d142$var$termsInput.checked) $6fb182d98681d142$var$submitBtn.disabled = false;
            else $6fb182d98681d142$var$submitBtn.disabled = true;
        });
    });
}
function $6fb182d98681d142$var$handleCloseButton() {
    if (window.closeButton) $6fb182d98681d142$var$submitBtn.insertAdjacentHTML("afterend", window.closeButton);
    const closeButton = $6fb182d98681d142$var$modal.querySelector(".oos-close-modal");
    closeButton?.addEventListener("click", ()=>$6fb182d98681d142$var$showModal(false));
}
function $6fb182d98681d142$var$handleSlideOut(body) {
    // allow buffer time for slide out before exiting popup
    const slideOutLayer = document.createElement("div");
    slideOutLayer.className = "trigger-slide-out";
    slideOutLayer.addEventListener("click", ()=>$6fb182d98681d142$var$showModal(false));
    body.insertAdjacentElement("afterbegin", slideOutLayer);
}
const $6fb182d98681d142$var$observer = new MutationObserver((mutationsList, observer)=>{
    const modalTrigger = document.querySelector(".product__oos-trigger");
    if (modalTrigger) {
        // Hide original btn
        const ogSubmit = document.querySelector(".product__submit__holder--notification");
        if (ogSubmit) ogSubmit.style.display = "none";
        // Add klaviyo modal
        modalTrigger?.addEventListener("click", $6fb182d98681d142$var$handleModal);
        observer.disconnect();
    }
});
$6fb182d98681d142$var$observer.observe(document.body, {
    childList: true,
    subtree: true
});


document.addEventListener("DOMContentLoaded", ()=>{
    const menuContainer = document.getElementById("nav-drawer__container");
    const submenuToggles = document.querySelectorAll(".nav-drawer__submenu-toggle");
    const backButton = document.querySelector(".nav-drawer__back-to-menu");
    const drawerLogo = document.querySelector(".drawer__title");
    const menuTitle = document.querySelector(".drawer__menu-title");
    const secondaryMenu = document.querySelector(".nav-drawer__menu-secondary");
    const updateContainerHeight = (menu)=>{
        const height = menu.scrollHeight;
        menuContainer.style.height = `${height}px`;
    };
    const resizeObserver = new ResizeObserver(()=>{
        updateContainerHeight(document.querySelector(".nav-drawer__level.active"));
    });
    resizeObserver.observe(menuContainer);
    submenuToggles.forEach((toggle)=>{
        toggle.addEventListener("click", (e)=>{
            const target = document.getElementById(e.currentTarget.dataset.target);
            const currentMenu = e.currentTarget.dataset.menuTitle;
            document.querySelector(".nav-drawer__level.active").classList.remove("active");
            drawerLogo?.classList.remove("active");
            target.classList.add("active");
            backButton.classList.add("active");
            updateContainerHeight(target);
            menuTitle.classList.remove("hidden");
            menuTitle.textContent = currentMenu;
        });
    });
    backButton.addEventListener("click", (e)=>{
        const target = document.getElementById(e.currentTarget.dataset.target);
        document.querySelector(".nav-drawer__level.active").classList.remove("active");
        backButton.classList.remove("active");
        drawerLogo?.classList.add("active");
        target.classList.add("active");
        menuTitle.classList.add("hidden");
        setTimeout(()=>{
            updateContainerHeight(target);
        }, 100);
    });
});


/**
 * Sticky Product Sidebar
 *
 * Manages sticky behavior for product details sidebar on desktop.
 * Uses a class-based state machine with automatic layout detection.
 */ /**
 * StickyProductController - Main controller for sticky product sidebar behavior
 *
 * Manages the lifecycle of the sticky product sidebar, including:
 * - Element discovery and validation
 * - Scroll handling with RAF batching
 * - Observer management for layout changes
 * - State transitions and CSS application
 */ /**
 * Configuration and constants for sticky product sidebar
 */ const $8fe52b714aee1e42$export$96d9f1a404a17825 = {
    STATIC: "static",
    STICKY: "sticky",
    STOPPED: "stopped" // Past stop marker (element pinned at stop position)
};
const $8fe52b714aee1e42$export$1630b5343357e8b5 = {
    selectors: {
        // Main container with sticky enabled
        container: '.product-single[data-sticky-enabled="true"]',
        // The element that will become sticky
        stickyElement: ".product-single__details",
        // Navigation for offset calculation (legacy, now using CSS variable)
        navigation: "nav#NavStandard",
        // Marker indicating where sticky should stop
        stopMarker: "[sticky-stop-marker]",
        // Main content container (absolute positioning parent)
        mainContent: "#MainContent",
        // Fallback stop element if no marker found
        footer: "#SiteFooter"
    },
    // Minimum viewport width for sticky behavior
    breakpoint: 768,
    // Spacing below sticky element when stopped
    spacing: {
        withMarker: 0,
        withoutMarker: 60 // Extra spacing when using footer as fallback
    }
};


/**
 * MeasurementCache - Caches expensive DOM measurements and handles invalidation
 *
 * This class stores all dimension and position measurements needed for sticky calculations.
 * It prevents redundant getBoundingClientRect() calls on every scroll event.
 */ class $295074703a2485a5$export$3c29232e51c6f838 {
    constructor(){
        this.cache = {};
        this.valid = false;
        this.stableValid = false; // Stable values (offset, height) remain valid on layout changes
        this.timestamp = null;
    }
    /**
	 * Measure all required dimensions and positions
	 * @param {Object} elements - Object containing all required DOM elements
	 * @returns {Object} The measured values
	 */ measure(elements) {
        if (!elements || !elements.stickyElement) {
            this.valid = false;
            return null;
        }
        try {
            // Sticky header height from CSS variable (works on all breakpoints)
            const stickyHeaderHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue("--header-sticky-height")) || 60;
            this.cache.navHeight = stickyHeaderHeight;
            // Main content top position (absolute positioning parent)
            const mainContentRect = elements.mainContent?.getBoundingClientRect();
            this.cache.mainContentTop = mainContentRect ? window.scrollY + mainContentRect.top : 0;
            // Product section (container) top position
            const containerRect = elements.container.getBoundingClientRect();
            this.cache.containerTop = window.scrollY + containerRect.top;
            // Sticky element height and RELATIVE offset from container
            // We store the offset instead of absolute position because:
            // - The offset doesn't change when other sections load above
            // - Absolute position can be computed: containerTop + offset
            const stickyRect = elements.stickyElement.getBoundingClientRect();
            this.cache.stickyHeight = stickyRect.height;
            this.cache.stickyOffsetFromContainer = stickyRect.top - containerRect.top;
            // Stop element top position
            if (elements.stopElement) {
                const stopRect = elements.stopElement.getBoundingClientRect();
                this.cache.stopElementTop = window.scrollY + stopRect.top;
            } else this.cache.stopElementTop = null;
            this.valid = true;
            this.stableValid = true;
            this.timestamp = Date.now();
            return this.cache;
        } catch (error) {
            console.error("Error measuring sticky product elements:", error);
            this.valid = false;
            this.stableValid = false;
            return null;
        }
    }
    /**
	 * Remeasure only layout-dependent values (container/stop positions)
	 * Use when sections load and push content down, but sticky element itself hasn't changed
	 * @param {Object} elements - Object containing all required DOM elements
	 */ measureLayout(elements) {
        if (!elements?.container) return;
        // Remeasure container position
        const containerRect = elements.container.getBoundingClientRect();
        this.cache.containerTop = window.scrollY + containerRect.top;
        // Remeasure main content position
        const mainContentRect = elements.mainContent?.getBoundingClientRect();
        this.cache.mainContentTop = mainContentRect ? window.scrollY + mainContentRect.top : 0;
        // Remeasure stop element position
        if (elements.stopElement) {
            const stopRect = elements.stopElement.getBoundingClientRect();
            this.cache.stopElementTop = window.scrollY + stopRect.top;
        }
        this.valid = true;
        this.timestamp = Date.now();
    }
    /**
	 * Mark the cache as fully invalid (needs full remeasurement)
	 */ invalidate() {
        this.valid = false;
        this.stableValid = false;
    }
    /**
	 * Mark only layout-dependent values as invalid
	 * Stable values (stickyHeight, stickyOffsetFromContainer, navHeight) remain valid
	 */ invalidateLayout() {
        this.valid = false;
    // stableValid stays true
    }
    /**
	 * Check if cache is valid
	 * @returns {boolean}
	 */ isValid() {
        return this.valid;
    }
    /**
	 * Check if stable values are still valid (can use measureLayout instead of full measure)
	 * @returns {boolean}
	 */ hasStableValues() {
        return this.stableValid;
    }
    /**
	 * Get a specific cached value
	 * @param {string} key - The measurement key
	 * @returns {*} The cached value or null if invalid
	 */ get(key) {
        return this.valid ? this.cache[key] : null;
    }
    /**
	 * Get all cached measurements
	 * @returns {Object|null} All measurements or null if invalid
	 */ getAll() {
        return this.valid ? {
            ...this.cache
        } : null;
    }
}


/**
 * Position Calculator - Pure functions for sticky state and position calculations
 *
 * These functions have no side effects and are fully testable.
 * They determine the sticky state and calculate the appropriate CSS values.
 */ 
function $66c2bd715374aa9e$export$9e989860e91bda4b(cache) {
    if (!cache) return {
        stickyStart: 0,
        stickyEnd: 0
    };
    const STICKY_OFFSET = 16; // Additional spacing below header when sticky
    // Compute absolute stickyElementTop from container position + relative offset
    // This works correctly even when other sections load and push content down,
    // because the offset (relative position within container) doesn't change
    const stickyElementTop = cache.containerTop + cache.stickyOffsetFromContainer;
    // Sticky starts when scroll would push sidebar behind header
    const stickyStart = stickyElementTop - (cache.navHeight + STICKY_OFFSET);
    // Sticky ends when bottom of sticky element would pass stop marker
    const stickyEnd = cache.stopElementTop ? cache.stopElementTop - (cache.navHeight + STICKY_OFFSET) - cache.stickyHeight : Infinity;
    return {
        stickyStart: stickyStart,
        stickyEnd: stickyEnd
    };
}
function $66c2bd715374aa9e$export$698fa70a2ac15688(scrollY, thresholds) {
    if (scrollY < thresholds.stickyStart) return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC;
    if (thresholds.stickyEnd !== Infinity && scrollY >= thresholds.stickyEnd) return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STOPPED;
    return (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STICKY;
}
function $66c2bd715374aa9e$export$a5b21f38d58b1de0(state, cache, hasStopMarker) {
    if (!cache) return {
        position: "",
        top: ""
    };
    switch(state){
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC:
            // Position absolute to override default CSS fixed positioning
            // But don't set top value - let element stay at natural layout position
            return {
                position: "absolute",
                top: ""
            };
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STICKY:
            // Fixed to viewport with 16px spacing below header
            return {
                position: "fixed",
                top: `${cache.navHeight + 16}px`
            };
        case (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STOPPED:
            // Absolute position pinned at stop marker
            const spacing = hasStopMarker ? 0 : 60;
            const absoluteTop = cache.stopElementTop - cache.mainContentTop - cache.stickyHeight - spacing;
            return {
                position: "absolute",
                top: `${absoluteTop}px`
            };
        default:
            return {
                position: "",
                top: ""
            };
    }
}


class $d4d227e85f07adb6$export$fd284eb6bfa30e95 {
    constructor(config = (0, $8fe52b714aee1e42$export$1630b5343357e8b5)){
        this.config = config;
        this.elements = null;
        this.cache = new (0, $295074703a2485a5$export$3c29232e51c6f838)();
        this.currentState = null;
        this.scrollRAF = null;
        this.stickyResizeObserver = null; // For sticky element - needs full invalidation
        this.layoutResizeObserver = null; // For layout elements - only layout invalidation
        this.mutationObserver = null;
        this.boundScrollHandler = null;
        this.hasStopMarker = false;
        this.activeStopSectionId = null; // Track which section we're using as stop marker
        this.isActive = false; // Track if controller is currently active
    }
    /**
	 * Initialize the sticky product behavior
	 */ init() {
        // Check viewport width
        if (window.innerWidth <= this.config.breakpoint) {
            this.isActive = false;
            return;
        }
        // Find and validate elements
        this.elements = this.findElements();
        if (!this.elements) {
            this.isActive = false;
            return;
        }
        // Reset any previous inline styles
        this.resetStyles();
        // Initial measurement
        this.cache.measure(this.elements);
        // Set initial position to STATIC (natural position) to prevent CLS jump
        // Even if scroll is past sticky threshold, start at natural position
        // Scroll handler will smoothly transition to sticky when needed
        const measurements = this.cache.getAll();
        if (measurements) {
            this.currentState = (0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC;
            this.applyStyles((0, $8fe52b714aee1e42$export$96d9f1a404a17825).STATIC, measurements);
        }
        // Setup event listeners and observers
        this.setupEventListeners();
        this.setupObservers();
        // Mark as active after successful initialization
        this.isActive = true;
    }
    /**
	 * Find all required DOM elements with scoped selection
	 * @returns {Object|null} Elements object or null if not found
	 */ findElements() {
        const container = document.querySelector(this.config.selectors.container);
        if (!container) return null;
        // Scoped selection: find sticky element within container
        const stickyElement = container.querySelector(this.config.selectors.stickyElement);
        if (!stickyElement) return null;
        const navigation = document.querySelector(this.config.selectors.navigation);
        const mainContent = document.querySelector(this.config.selectors.mainContent);
        const stopElement = this.findStopElement();
        if (!navigation || !mainContent) return null;
        return {
            container: container,
            stickyElement: stickyElement,
            navigation: navigation,
            mainContent: mainContent,
            stopElement: stopElement
        };
    }
    /**
	 * Find the stop element (marker or footer fallback)
	 * Filters out hidden sections and returns the first visible marker
	 * @returns {HTMLElement|null}
	 */ findStopElement() {
        // Find all markers
        const markers = document.querySelectorAll(this.config.selectors.stopMarker);
        if (markers.length === 0) {
            // No markers found, fallback to footer
            this.hasStopMarker = false;
            this.activeStopSectionId = null;
            return document.querySelector(this.config.selectors.footer);
        }
        // Filter to visible markers only
        const visibleMarkers = Array.from(markers).filter((marker)=>{
            const section = marker.closest(".shopify-section");
            if (!section) return false;
            // Check if section is hidden
            const styles = window.getComputedStyle(section);
            return styles.display !== "none" && styles.visibility !== "hidden";
        });
        if (visibleMarkers.length === 0) {
            // No visible markers, use footer
            this.hasStopMarker = false;
            this.activeStopSectionId = null;
            return document.querySelector(this.config.selectors.footer);
        }
        // Get the first visible marker (the section element itself)
        const stopElement = visibleMarkers[0];
        this.hasStopMarker = true;
        // Store the section ID of the stop element we're using
        const stopSection = stopElement.closest("[data-section-id]");
        this.activeStopSectionId = stopSection?.getAttribute("data-section-id") || null;
        return stopElement;
    }
    /**
	 * Reset inline styles to prevent stale state
	 */ resetStyles() {
        if (this.elements?.stickyElement) {
            this.elements.stickyElement.style.position = "";
            this.elements.stickyElement.style.top = "";
        }
    }
    /**
	 * Setup scroll event listener with RAF batching
	 */ setupEventListeners() {
        this.boundScrollHandler = ()=>this.handleScroll();
        window.addEventListener("scroll", this.boundScrollHandler, {
            passive: true
        });
    }
    /**
	 * Setup ResizeObserver and MutationObserver for automatic invalidation
	 */ setupObservers() {
        // ResizeObserver for sticky element - needs full invalidation
        // (stickyHeight and stickyOffsetFromContainer may have changed)
        this.stickyResizeObserver = new ResizeObserver(()=>{
            this.invalidate();
        });
        if (this.elements.stickyElement) this.stickyResizeObserver.observe(this.elements.stickyElement);
        // ResizeObserver for layout elements - only layout invalidation
        // (only container/stop positions changed, not the sticky element itself)
        this.layoutResizeObserver = new ResizeObserver(()=>{
            this.invalidateLayout();
        });
        if (this.elements.stopElement) this.layoutResizeObserver.observe(this.elements.stopElement);
        if (this.elements.mainContent) this.layoutResizeObserver.observe(this.elements.mainContent);
        // MutationObserver: Watch for new sections AND attribute/style changes
        this.mutationObserver = new MutationObserver((mutations)=>{
            let needsRefind = false;
            mutations.forEach((mutation)=>{
                // Check for new nodes added
                if (mutation.type === "childList" && mutation.addedNodes.length > 0) needsRefind = true;
                // Check for style/attribute changes that might hide/show sections
                if (mutation.type === "attributes" && (mutation.attributeName === "style" || mutation.attributeName === "class")) // A section might have been hidden or shown
                needsRefind = true;
            });
            if (needsRefind) this.refindStopElement();
        });
        if (this.elements.mainContent) this.mutationObserver.observe(this.elements.mainContent, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: [
                "style",
                "class"
            ] // Only style/class changes
        });
    }
    /**
	 * Refind the stop element and update observers if it changed
	 * This handles cases where sections are hidden/shown or added/removed
	 */ refindStopElement() {
        const newStopElement = this.findStopElement();
        if (newStopElement !== this.elements.stopElement) {
            // Disconnect old observer from old stop element
            if (this.elements.stopElement && this.layoutResizeObserver) this.layoutResizeObserver.unobserve(this.elements.stopElement);
            // Update reference
            this.elements.stopElement = newStopElement;
            // Observe new stop element
            if (newStopElement && this.layoutResizeObserver) this.layoutResizeObserver.observe(newStopElement);
            // Use layout invalidation to preserve stable values (stickyOffsetFromContainer)
            // Full invalidation would cause wrong measurements if element is in STICKY state
            this.invalidateLayout();
        }
    }
    /**
	 * Handle scroll event with RAF batching
	 */ handleScroll() {
        // Cancel pending frame if scrolling quickly
        if (this.scrollRAF) cancelAnimationFrame(this.scrollRAF);
        this.scrollRAF = requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Update position based on current scroll position
	 */ updatePosition() {
        // Guard against missing elements
        if (!this.elements || !document.body.contains(this.elements.stickyElement)) return;
        // Check viewport width
        if (window.innerWidth < this.config.breakpoint) return;
        // Remeasure if cache is invalid
        if (!this.cache.isValid()) {
            // Use partial remeasurement if stable values are still valid
            // (e.g., when other sections loaded but sticky element itself didn't change)
            if (this.cache.hasStableValues()) this.cache.measureLayout(this.elements);
            else this.cache.measure(this.elements);
        }
        const measurements = this.cache.getAll();
        if (!measurements) return;
        // Calculate thresholds and determine state
        const scrollY = window.scrollY;
        const thresholds = (0, $66c2bd715374aa9e$export$9e989860e91bda4b)(measurements);
        const newState = (0, $66c2bd715374aa9e$export$698fa70a2ac15688)(scrollY, thresholds);
        // Apply styles if state changed
        if (newState !== this.currentState) {
            this.currentState = newState;
            this.applyStyles(newState, measurements);
            this.dispatchStateChange(newState, scrollY);
        }
    }
    /**
	 * Apply CSS styles for the given state
	 * @param {string} state - STICKY_STATE value
	 * @param {Object} measurements - Cached measurements
	 */ applyStyles(state, measurements) {
        if (!this.elements?.stickyElement) return;
        const styles = (0, $66c2bd715374aa9e$export$a5b21f38d58b1de0)(state, measurements, this.hasStopMarker);
        this.elements.stickyElement.style.position = styles.position;
        this.elements.stickyElement.style.top = styles.top;
    }
    /**
	 * Dispatch custom event when state changes
	 * @param {string} state - New state
	 * @param {number} scrollY - Current scroll position
	 */ dispatchStateChange(state, scrollY) {
        const event = new CustomEvent("sticky-product:state-change", {
            detail: {
                state: state,
                scrollY: scrollY,
                measurements: this.cache.getAll()
            }
        });
        document.dispatchEvent(event);
    }
    /**
	 * Invalidate cache and trigger recalculation
	 */ invalidate() {
        this.cache.invalidate();
        // Trigger immediate recalculation
        requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Invalidate only layout-dependent values (for when other sections load)
	 * This preserves stable measurements like stickyOffsetFromContainer
	 */ invalidateLayout() {
        this.cache.invalidateLayout();
        requestAnimationFrame(()=>{
            this.updatePosition();
        });
    }
    /**
	 * Cleanup and destroy the controller
	 */ destroy() {
        // Remove scroll listener
        if (this.boundScrollHandler) {
            window.removeEventListener("scroll", this.boundScrollHandler);
            this.boundScrollHandler = null;
        }
        // Cancel pending RAF
        if (this.scrollRAF) {
            cancelAnimationFrame(this.scrollRAF);
            this.scrollRAF = null;
        }
        // Disconnect observers
        if (this.stickyResizeObserver) {
            this.stickyResizeObserver.disconnect();
            this.stickyResizeObserver = null;
        }
        if (this.layoutResizeObserver) {
            this.layoutResizeObserver.disconnect();
            this.layoutResizeObserver = null;
        }
        if (this.mutationObserver) {
            this.mutationObserver.disconnect();
            this.mutationObserver = null;
        }
        // Reset styles
        this.resetStyles();
        // Clear references
        this.elements = null;
        this.cache.invalidate();
        this.currentState = null;
        // Mark as inactive
        this.isActive = false;
    }
}


// Global controller instance
let $5901807e870bca0b$var$stickyController = null;
/**
 * Initialize or reinitialize the sticky product controller
 */ function $5901807e870bca0b$var$initializeStickyProduct() {
    // Destroy existing instance if present
    if ($5901807e870bca0b$var$stickyController) {
        $5901807e870bca0b$var$stickyController.destroy();
        $5901807e870bca0b$var$stickyController = null;
    }
    // Create and initialize new controller
    $5901807e870bca0b$var$stickyController = new (0, $d4d227e85f07adb6$export$fd284eb6bfa30e95)();
    $5901807e870bca0b$var$stickyController.init();
}
/**
 * Reinitialize with double RAF for layout settling
 */ function $5901807e870bca0b$var$reinitialize() {
    requestAnimationFrame(()=>{
        requestAnimationFrame(()=>{
            $5901807e870bca0b$var$initializeStickyProduct();
        });
    });
}
// Initialize on DOMContentLoaded
document.addEventListener("DOMContentLoaded", ()=>{
    $5901807e870bca0b$var$initializeStickyProduct();
});
// Handle viewport resize (mobile ↔ desktop transitions)
let $5901807e870bca0b$var$lastViewportWasDesktop = window.innerWidth > 768;
window.addEventListener("resize", ()=>{
    const isDesktop = window.innerWidth > 768;
    // Mobile → Desktop: Initialize if not already active
    if (!$5901807e870bca0b$var$lastViewportWasDesktop && isDesktop) {
        if (!$5901807e870bca0b$var$stickyController || !$5901807e870bca0b$var$stickyController.isActive) $5901807e870bca0b$var$initializeStickyProduct();
    }
    // Desktop → Mobile: Destroy and clean up
    if ($5901807e870bca0b$var$lastViewportWasDesktop && !isDesktop) {
        if ($5901807e870bca0b$var$stickyController) {
            $5901807e870bca0b$var$stickyController.destroy();
            $5901807e870bca0b$var$stickyController = null;
        }
    }
    $5901807e870bca0b$var$lastViewportWasDesktop = isDesktop;
});
// Smart reinitialization when filtered product list rerenders
// Only do full reinit if the changed section is the active stop marker
document.addEventListener("filtered-product-list:loaded", (event)=>{
    const changedSectionId = event.detail?.sectionId;
    // Check if this section is the one we're using as stop marker
    if ($5901807e870bca0b$var$stickyController && $5901807e870bca0b$var$stickyController.isActive) {
        const isActiveStopSection = $5901807e870bca0b$var$stickyController.activeStopSectionId === changedSectionId;
        if (isActiveStopSection) // Stop marker section changed - need full reinit
        $5901807e870bca0b$var$reinitialize();
        else // Other section loaded - just invalidate layout measurements
        // This recalculates container/stop positions while preserving
        // the stable stickyOffsetFromContainer value
        $5901807e870bca0b$var$stickyController.invalidateLayout();
    }
});


class $5d82383b721ae4ef$var$ShippingCutoffCountdown extends HTMLElement {
    constructor(){
        super();
        this.timezone = this.dataset.timezone || "Europe/Copenhagen";
        this.cutoffHour = parseInt(this.dataset.cutoffHour) || 14;
        this.cutoffMinute = parseInt(this.dataset.cutoffMinute) || 0;
        this.minimumHours = parseInt(this.dataset.minimumHours) || 6;
        this.updateInterval = null;
        this.countdownWrapper = null;
        this.tomorrowWrapper = null;
        this.globalCountdown = null;
    }
    connectedCallback() {
        this.countdownWrapper = this.querySelector('[data-countdown-state="countdown"]');
        this.tomorrowWrapper = this.querySelector('[data-countdown-state="tomorrow"]');
        this.countdownContainer = this.querySelector(".shipping-cutoff__countdown-container");
        this.checkAndRender();
        this.startCountdown();
        document.addEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
    }
    disconnectedCallback() {
        this.stopCountdown();
        document.removeEventListener("visibilitychange", this.handleVisibilityChange.bind(this));
    }
    handleVisibilityChange() {
        if (document.hidden) this.stopCountdown();
        else {
            this.checkAndRender();
            this.startCountdown();
        }
    }
    getCopenhagenComponents() {
        const now = new Date();
        const formatter = new Intl.DateTimeFormat("en-US", {
            timeZone: this.timezone,
            hour12: false,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            weekday: "short"
        });
        const parts = formatter.formatToParts(now);
        const components = {};
        parts.forEach(({ type: type, value: value })=>{
            components[type] = value;
        });
        return components;
    }
    getCopenhagenDate() {
        const cph = this.getCopenhagenComponents();
        return new Date(`${cph.year}-${cph.month}-${cph.day}T${cph.hour}:${cph.minute}:${cph.second}`);
    }
    getDayOfWeek() {
        const cph = this.getCopenhagenComponents();
        const weekdayMap = {
            "Sun": 0,
            "Mon": 1,
            "Tue": 2,
            "Wed": 3,
            "Thu": 4,
            "Fri": 5,
            "Sat": 6
        };
        return weekdayMap[cph.weekday];
    }
    calculateTimeRemaining() {
        const cph = this.getCopenhagenComponents();
        const currentHour = parseInt(cph.hour);
        const currentMinute = parseInt(cph.minute);
        const currentSecond = parseInt(cph.second);
        const currentTotalSeconds = currentHour * 3600 + currentMinute * 60 + currentSecond;
        const cutoffTotalSeconds = this.cutoffHour * 3600 + this.cutoffMinute * 60;
        let secondsRemaining = cutoffTotalSeconds - currentTotalSeconds;
        if (secondsRemaining < 0) secondsRemaining = 0;
        const hours = Math.floor(secondsRemaining / 3600);
        const minutes = Math.floor(secondsRemaining % 3600 / 60);
        const seconds = secondsRemaining % 60;
        return {
            hours: hours,
            minutes: minutes,
            seconds: seconds,
            totalSeconds: secondsRemaining
        };
    }
    shouldDisplay() {
        const dayOfWeek = this.getDayOfWeek();
        if (dayOfWeek === 0 || dayOfWeek === 6) return {
            display: false,
            reason: "weekend"
        };
        const { hours: hours, totalSeconds: totalSeconds } = this.calculateTimeRemaining();
        if (totalSeconds === 0) {
            const isNextDayBusinessDay = this.isNextDayBusinessDay(dayOfWeek);
            if (isNextDayBusinessDay) return {
                display: true,
                state: "tomorrow"
            };
            return {
                display: false,
                reason: "past_cutoff_weekend"
            };
        }
        if (hours >= this.minimumHours) return {
            display: false,
            reason: "too_early"
        };
        return {
            display: true,
            state: "countdown"
        };
    }
    isNextDayBusinessDay(currentDayOfWeek) {
        return currentDayOfWeek >= 1 && currentDayOfWeek <= 4;
    }
    calculateCutoffDate() {
        const cph = this.getCopenhagenComponents();
        const year = parseInt(cph.year);
        const month = parseInt(cph.month);
        const day = parseInt(cph.day);
        const cutoffHourStr = String(this.cutoffHour).padStart(2, "0");
        const cutoffMinuteStr = String(this.cutoffMinute).padStart(2, "0");
        const dateString = `${year}-${month}-${day}T${cutoffHourStr}:${cutoffMinuteStr}:00`;
        const testDate = new Date(`${year}-${month}-${day}`);
        const isDST = this.isDSTActive(testDate);
        const offset = isDST ? "+02:00" : "+01:00";
        return `${dateString}${offset}`;
    }
    isDSTActive(date) {
        const dateStr = date.toLocaleString("en-US", {
            timeZone: this.timezone,
            timeZoneName: "short"
        });
        return dateStr.includes("CEST");
    }
    checkAndRender() {
        const shouldDisplay = this.shouldDisplay();
        if (!shouldDisplay.display) {
            this.style.display = "none";
            return;
        }
        this.style.display = "block";
        if (shouldDisplay.state === "countdown") this.renderCountdown();
        else if (shouldDisplay.state === "tomorrow") this.renderTomorrow();
    }
    renderCountdown() {
        const { hours: hours } = this.calculateTimeRemaining();
        const cutoffDateISO = this.calculateCutoffDate();
        if (this.countdownContainer) {
            if (!this.countdownContainer.querySelector("global-countdown")) {
                const countdown = document.createElement("global-countdown");
                countdown.setAttribute("data-target-date", cutoffDateISO);
                countdown.setAttribute("data-units", "hours:minutes:seconds");
                countdown.setAttribute("data-text-only", "true");
                countdown.setAttribute("data-zero-pad", "true");
                countdown.setAttribute("data-hide-zero-units", "true");
                countdown.setAttribute("data-i18n-hour", this.countdownContainer.dataset.i18nHour || "Hour");
                countdown.setAttribute("data-i18n-hours", this.countdownContainer.dataset.i18nHours || "Hours");
                countdown.setAttribute("data-i18n-minute", this.countdownContainer.dataset.i18nMinute || "Minute");
                countdown.setAttribute("data-i18n-minutes", this.countdownContainer.dataset.i18nMinutes || "Minutes");
                countdown.setAttribute("data-i18n-second", this.countdownContainer.dataset.i18nSecond || "Second");
                countdown.setAttribute("data-i18n-seconds", this.countdownContainer.dataset.i18nSeconds || "Seconds");
                countdown.setAttribute("role", "timer");
                countdown.setAttribute("aria-live", "polite");
                countdown.setAttribute("aria-atomic", "true");
                countdown.setAttribute("aria-label", this.countdownContainer.dataset.ariaLabel || "Shipping countdown");
                this.countdownContainer.appendChild(countdown);
            } else {
                const existingCountdown = this.countdownContainer.querySelector("global-countdown");
                const currentDate = existingCountdown.getAttribute("data-target-date");
                if (currentDate !== cutoffDateISO) existingCountdown.setAttribute("data-target-date", cutoffDateISO);
            }
        }
        const urgencyClass = hours < 1 ? "shipping-cutoff--high-urgency" : "shipping-cutoff--countdown";
        if (this.countdownWrapper) {
            this.countdownWrapper.className = `shipping-cutoff__countdown-wrapper ${urgencyClass}`;
            this.countdownWrapper.style.display = "block";
        }
        if (this.tomorrowWrapper) this.tomorrowWrapper.style.display = "none";
        this.dispatchEvent(new CustomEvent("shipping-cutoff:displayed", {
            bubbles: true,
            detail: {
                hoursRemaining: hours,
                state: "countdown"
            }
        }));
    }
    renderTomorrow() {
        if (this.countdownWrapper) this.countdownWrapper.style.display = "none";
        if (this.countdownContainer) this.countdownContainer.innerHTML = "";
        if (this.tomorrowWrapper) {
            this.tomorrowWrapper.className = "shipping-cutoff__tomorrow-wrapper shipping-cutoff--tomorrow";
            this.tomorrowWrapper.style.display = "block";
        }
        this.dispatchEvent(new CustomEvent("shipping-cutoff:displayed", {
            bubbles: true,
            detail: {
                state: "tomorrow"
            }
        }));
    }
    startCountdown() {
        this.stopCountdown();
        this.updateInterval = setInterval(()=>{
            this.checkAndRender();
        }, 30000);
    }
    stopCountdown() {
        if (this.updateInterval) {
            clearInterval(this.updateInterval);
            this.updateInterval = null;
        }
    }
}
customElements.define("shipping-cutoff-countdown", $5d82383b721ae4ef$var$ShippingCutoffCountdown);


parcelRequire("adV76");
parcelRequire("gQTes");
parcelRequire("h17mq");
parcelRequire("ghscK");
parcelRequire("jPzyF");


parcelRequire("aJzli");
class $b95e12d3b41f8924$var$VideoAutoplay {
    constructor(){
        this.observedVideos = new WeakSet();
        this.init();
    }
    init() {
        this.setupIntersectionObserver();
        this.observeExistingVideos();
        this.setupMutationObserver();
    }
    setupIntersectionObserver() {
        this.intersectionObserver = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                const video = entry.target;
                if (entry.isIntersecting) this.playVideo(video);
                else this.pauseVideo(video);
            });
        }, {
            threshold: 0.10,
            rootMargin: "0px"
        });
    }
    setupMutationObserver() {
        this.mutationObserver = new MutationObserver((mutations)=>{
            mutations.forEach((mutation)=>{
                mutation.addedNodes.forEach((node)=>{
                    if (node.nodeType === 1) {
                        if (node.tagName === "VIDEO" && node.getAttribute("data-autoplay") === "true") this.observeVideo(node);
                        const videos = node.querySelectorAll?.('video[data-autoplay="true"]');
                        videos?.forEach((video)=>this.observeVideo(video));
                    }
                });
            });
        });
        this.mutationObserver.observe(document.body, {
            childList: true,
            subtree: true
        });
    }
    observeExistingVideos() {
        const videos = document.querySelectorAll('video[data-autoplay="true"]');
        videos.forEach((video)=>this.observeVideo(video));
    }
    observeVideo(video) {
        if (this.observedVideos.has(video)) return;
        this.observedVideos.add(video);
        this.intersectionObserver.observe(video);
        this.setupIOSWorkaround(video);
    }
    setupIOSWorkaround(video) {
        const container = video.closest("[data-video-container]") || video.parentElement;
        const touchHandler = ()=>{
            if (video.paused && this.isVideoInViewport(video)) this.playVideo(video);
        };
        container.addEventListener("touchstart", touchHandler, {
            passive: true,
            once: true
        });
    }
    isVideoInViewport(video) {
        const rect = video.getBoundingClientRect();
        const windowHeight = window.innerHeight || document.documentElement.clientHeight;
        const windowWidth = window.innerWidth || document.documentElement.clientWidth;
        const vertInView = rect.top <= windowHeight && rect.top + rect.height >= 0;
        const horInView = rect.left <= windowWidth && rect.left + rect.width >= 0;
        return vertInView && horInView;
    }
    playVideo(video) {
        const playPromise = video.play();
        if (playPromise !== undefined) playPromise.catch((error)=>{
            console.warn("Video autoplay failed:", error);
        });
    }
    pauseVideo(video) {
        if (!video.paused) video.pause();
    }
    destroy() {
        this.intersectionObserver?.disconnect();
        this.mutationObserver?.disconnect();
    }
}
var $b95e12d3b41f8924$export$2e2bcd8739ae039 = $b95e12d3b41f8924$var$VideoAutoplay;


let $86d221be59603aa4$var$videoAutoplayInstance = null;
document.addEventListener("DOMContentLoaded", ()=>{
    $86d221be59603aa4$var$videoAutoplayInstance = new (0, $b95e12d3b41f8924$export$2e2bcd8739ae039)();
});


parcelRequire("9sPuh");
class $54f9f862ec1657cf$var$VisionTestModal extends HTMLElement {
    constructor(){
        super();
        this.isOpen = false;
        this.iframe = null;
        this.iframeLoaded = false;
    }
    connectedCallback() {
        this.overlay = this.querySelector(".vision-test-modal__overlay");
        this.panel = this.querySelector(".vision-test-modal__panel");
        this.closeButton = this.querySelector(".vision-test-modal__close");
        this.iframeContainer = this.querySelector(".vision-test-modal__iframe-container");
        this.setupEventListeners();
        this.initializeTriggers();
    }
    setupEventListeners() {
        this.closeButton?.addEventListener("click", ()=>this.close());
        this.overlay?.addEventListener("click", ()=>this.close());
        document.addEventListener("keydown", (e)=>{
            if (e.key === "Escape" && this.isOpen) this.close();
        });
    }
    initializeTriggers() {
        const triggers = document.querySelectorAll("[data-vision-test-trigger]");
        triggers.forEach((trigger)=>{
            trigger.addEventListener("click", (e)=>{
                e.preventDefault();
                this.open();
            });
        });
    }
    async open() {
        if (!this.iframeLoaded) await this.loadIframe();
        this.isOpen = true;
        this.classList.add("is-open");
        document.body.style.overflow = "hidden";
        sessionStorage.setItem("vision_test_interaction", "true");
    }
    close() {
        this.isOpen = false;
        this.classList.remove("is-open");
        document.body.style.overflow = "";
    }
    async loadIframe() {
        const iframeUrl = window.theme.settings.visionTestUrl || "https://luxreaders-visiontest.netlify.app/da";
        this.iframe = document.createElement("iframe");
        this.iframe.src = iframeUrl;
        this.iframe.className = "vision-test-modal__iframe";
        this.iframe.title = window.theme.strings.vision_test.iframe_title;
        this.iframe.setAttribute("frameborder", "0");
        this.iframe.setAttribute("allowfullscreen", "true");
        this.iframeContainer.innerHTML = `<div class="vision-test-modal__loading">${window.theme.strings.vision_test.loading}</div>`;
        this.iframeContainer.appendChild(this.iframe);
        this.iframe.addEventListener("load", ()=>{
            this.iframeContainer.querySelector(".vision-test-modal__loading")?.remove();
        });
        this.iframeLoaded = true;
    }
}
customElements.define("vision-test-modal", $54f9f862ec1657cf$var$VisionTestModal);


if (window.theme?.sizes) window.theme.sizes.large = 1048;

})();
//# sourceMappingURL=parcel_scripts.js.map
